// Built from design-studio.html by build_theme.py (v17). Edit the source, not this file.
(() => {
"use strict";
document.getElementById("ds-root").innerHTML = "\n\n  <div class=\"grid\">\n    <main>\n      <div class=\"bags-bar\" aria-label=\"Bag designs in this order\">\n        <span class=\"bags-label\">Your bags</span>\n        <div class=\"bags-tabs\" id=\"bagTabs\" role=\"tablist\"></div>\n        <button type=\"button\" class=\"add-btn\" id=\"addBag\">+ Add another bag</button>\n        <div class=\"kind-switch\" role=\"radiogroup\" aria-label=\"This bag is\">\n          <span class=\"bags-label\" id=\"kindLabel\">Bag 1 is</span>\n          <button type=\"button\" role=\"radio\" data-kind=\"new\" aria-checked=\"true\">A new design</button>\n          <button type=\"button\" role=\"radio\" data-kind=\"reorder\" aria-checked=\"false\">A reorder of a past design</button>\n        </div>\n      </div>\n      <section class=\"step\" aria-labelledby=\"h-series\">\n        <h2 id=\"h-series\"><span class=\"n\">01</span>Pick your bag</h2>\n        <p class=\"sub\">Every bag has a slow side and a fast side. Speed is rated 1 to 10, from our <a href=\"https://www.brotherhoodcornhole.com/pages/bag-speed-chart\" style=\"color:var(--accent)\">bag speed chart</a>. Higher slides farther.</p>\n        <div class=\"tabs\" id=\"programTabs\" role=\"group\" aria-label=\"Program\"></div>\n        <div class=\"cards\" id=\"seriesCards\" role=\"radiogroup\" aria-labelledby=\"h-series\"></div>\n      </section>\n\n      <section class=\"step\" aria-labelledby=\"h-weight\">\n        <h2 id=\"h-weight\"><span class=\"n\">02</span>Weight</h2>\n        <p class=\"sub\" id=\"weightSub\"></p>\n        <div id=\"weightBox\"></div>\n      </section>\n\n      <section class=\"step\" aria-labelledby=\"h-carpet\">\n        <h2 id=\"h-carpet\"><span class=\"n\">03</span>Slow side colour</h2>\n        <p class=\"sub\" id=\"carpetSub\"></p>\n        <div id=\"carpetBox\"></div>\n        <p class=\"note\">On-screen colours are approximate. We can mail a physical swatch before production.</p>\n      </section>\n\n      <section class=\"step\" aria-labelledby=\"h-art\">\n        <h2 id=\"h-art\"><span class=\"n\">04</span>Design your bag</h2>\n        <p class=\"sub\">This is the printed fast side at full size, 7.25 in to the sewn edge. Every bag needs its ACL or ACO stamp, our logo and the series title. Add your own images and text, drag anything into place and resize it from the corner. Keep text and faces inside the dashed safe area.</p>\n        <div class=\"designer\">\n          <div class=\"editor-wrap\">\n            <div class=\"design-bag\" id=\"editor\" tabindex=\"0\" aria-label=\"Bag design. Select an image, then drag it or use the arrow keys to move it.\"></div>\n            <ul class=\"key\" aria-label=\"Template guides\">\n              <li><i class=\"cut\"></i>Cut edge, 7.25 in</li>\n              <li><i class=\"sewn\"></i>Sewn into the seam</li>\n              <li><i class=\"seam\"></i>Seam line</li>\n              <li><i class=\"safe\"></i>Safe area, 5.75 in</li>\n            </ul>\n            <p class=\"hint\">Tip: select an image or text, then use the arrow keys to nudge it. Delete removes it.</p>\n            <div class=\"required\" id=\"requiredNote\" aria-live=\"polite\"></div>\n          </div>\n          <div class=\"design-tools\">\n            <div class=\"tool-col\">\n              <div class=\"drop\" id=\"drop\">\n                <input type=\"file\" id=\"artInput\" accept=\"image/png,image/jpeg,image/webp,image/svg+xml,application/pdf\" multiple aria-label=\"Add images\">\n                <b>Add images</b>\n                <span>PNG, JPG, SVG or PDF. Photos need at least 1,100 px on the short side. Vector files (SVG, PDF, AI) are best.</span>\n              </div>\n              <ul class=\"rules\" aria-label=\"Artwork rules\">\n                <li>No trademarked or copyrighted artwork, including college and pro team logos.</li>\n                <li>No derogatory or explicit content.</li>\n                <li>No complete AI-generated or ChatGPT mockups as final artwork. We may use individual elements at our discretion.</li>\n              </ul>\n              <label class=\"check rights\" id=\"rightsRow\" hidden><input type=\"checkbox\" id=\"rightsOk\"> I own the images I've added or have permission to use them, and none of them is a team, brand or character logo.</label>\n              <div class=\"add-row\">\n                <button type=\"button\" class=\"add-btn\" id=\"addTitle\">+ Series title</button>\n                <button type=\"button\" class=\"add-btn\" id=\"addText\">+ Your text</button>\n              </div>\n              <ul class=\"layers\" id=\"layerList\" aria-label=\"On your bag\"></ul>\n            </div>\n            <div class=\"tool-col\">\n              <div class=\"place\">\n                <h3 id=\"inkTitle\">Logo &amp; text colour</h3>\n                <div class=\"ink\">\n                  <canvas id=\"wheel\" width=\"300\" height=\"300\" aria-label=\"Colour wheel: click or drag to pick a colour\" tabindex=\"0\"></canvas>\n                  <div class=\"ink-side\">\n                    <span class=\"ink-swatch\" id=\"inkSwatch\"></span>\n                    <label class=\"lbl-sm\" for=\"inkLight\">Brightness</label>\n                    <input type=\"range\" id=\"inkLight\" min=\"0\" max=\"100\" value=\"12\">\n                    <label class=\"lbl-sm\" for=\"inkHex\">Hex</label>\n                    <input type=\"text\" id=\"inkHex\" maxlength=\"7\" spellcheck=\"false\" value=\"#1F1D1E\">\n                    <div class=\"ink-quick\"><button type=\"button\" data-ink=\"#1F1D1E\" aria-label=\"Black\" style=\"background:#1F1D1E\"></button><button type=\"button\" data-ink=\"#FFFFFF\" aria-label=\"White\" style=\"background:#FFFFFF\"></button></div>\n                  </div>\n                </div>\n                <p class=\"hint\" style=\"margin-top:6px\">Colours our logo, the series title and your text.</p>\n              </div>\n              <div class=\"place\">\n                <h3 id=\"fontTitle\">Font for the title &amp; your text</h3>\n                <div class=\"font-row\">\n                  <label class=\"add-btn\" for=\"fontInput\">Upload a font</label>\n                  <input type=\"file\" id=\"fontInput\" accept=\".ttf,.otf,.woff,.woff2\" hidden>\n                  <button type=\"button\" class=\"add-btn\" id=\"fontReset\" hidden>Use our font</button>\n                </div>\n                <p class=\"hint\" id=\"fontMsg\">Using our default font. Want a different look? Grab a free font from\n                  <a href=\"https://www.dafont.com\" target=\"_blank\" rel=\"noopener\">DaFont</a>,\n                  <a href=\"https://fonts.google.com\" target=\"_blank\" rel=\"noopener\">Google Fonts</a> or\n                  <a href=\"https://www.fontsquirrel.com\" target=\"_blank\" rel=\"noopener\">Font Squirrel</a>, then upload the .ttf or .otf file here.</p>\n              </div>\n            <div class=\"place\">\n              <h3 id=\"aclTitle\">ACL stamp</h3>\n              <div class=\"spots\" id=\"spotsAcl\" role=\"radiogroup\" aria-labelledby=\"aclTitle\"></div>\n            </div>\n            <div class=\"place\">\n              <h3 id=\"bcTitle\">Brotherhood logo</h3>\n              <div class=\"spots\" id=\"spotsBc\" role=\"radiogroup\" aria-labelledby=\"bcTitle\"></div>\n            </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"art-status\" id=\"artStatus\" hidden><span class=\"dot\"></span><div id=\"artMsg\"></div></div>\n        <div class=\"concept\" aria-labelledby=\"h-concept\">\n          <h3 id=\"h-concept\">Concept artwork <span class=\"opt\">Optional \u00b7 not printed</span></h3>\n          <p>Have sketches, screenshots or photos of a look you like? Upload them here for our design team to work from. They're for reference only: they won't appear on your mockup or be printed as they are.</p>\n          <div class=\"drop\" id=\"conceptDrop\">\n            <input type=\"file\" id=\"conceptInput\" accept=\"image/*,application/pdf,.heic,.heif\" multiple aria-label=\"Add concept images\">\n            <b>Add concept images</b>\n            <span>Any image or PDF, up to 10 files (20 MB each). Small screenshots are fine here.</span>\n          </div>\n          <div class=\"concept-msg\" id=\"conceptMsg\" aria-live=\"polite\"></div>\n          <ul class=\"concept-list\" id=\"conceptList\" aria-label=\"Your concept images\"></ul>\n        </div>\n      </section>\n\n      <section class=\"step\" id=\"reorderStep\" aria-labelledby=\"h-reorder\" hidden>\n        <h2 id=\"h-reorder\"><span class=\"n\">04</span>Your past design</h2>\n        <p class=\"sub\">We'll print the exact design you had before, at our standard bag price with no design fee. You can change the slow-side colour.</p>\n        <div class=\"reorder-rule\"><b>The weight is printed on your bag, so a different weight means new artwork.</b>\n          Pick the same bag and weight as your original order above. Want a different bag or weight? Switch this bag to \"A new design\" at the top.</div>\n        <div id=\"pastPick\"></div>\n        <div id=\"reorderManual\">\n          <label class=\"lbl\" for=\"reorderOf\" id=\"reorderOfLbl\">Original order number or design reference</label>\n          <input type=\"text\" id=\"reorderOf\" class=\"text-in\" placeholder=\"e.g. #20986 or DS-7KQ4MX-1\" maxlength=\"40\" autocomplete=\"off\">\n          <p class=\"hint\" id=\"reorderOfHint\">Find it in your order confirmation email.</p>\n          <label class=\"check\" id=\"reorderOkRow\"><input type=\"checkbox\" id=\"reorderOk\"> This is the same bag and weight as my original order.</label>\n        </div>\n      </section>\n\n      <section class=\"step\" aria-labelledby=\"h-qty\">\n        <h2 id=\"h-qty\"><span class=\"n\">05</span>Quantity &amp; notes</h2>\n        <p class=\"sub\">A set is four bags: two for each team, all with the same design.</p>\n        <div class=\"qty\">\n          <button type=\"button\" id=\"qMinus\" aria-label=\"One fewer set\">\u2212</button>\n          <input id=\"qty\" type=\"number\" min=\"1\" max=\"500\" value=\"1\" inputmode=\"numeric\" aria-label=\"Number of sets\">\n          <button type=\"button\" id=\"qPlus\" aria-label=\"One more set\">+</button>\n          <span class=\"eq\" id=\"qEq\"></span>\n        </div>\n        <p class=\"notes-tip\">Please feel free to leave our design team notes on strokes or colors for the Brotherhood logo and any text on your bag.</p>\n        <label class=\"lbl\" for=\"notes\">Notes for the design team</label>\n        <textarea id=\"notes\" placeholder=\"e.g. Match the gold to our league logo, event date Oct 18\"></textarea>\n      </section>\n\n      <section class=\"stock\" id=\"stockPanel\" aria-labelledby=\"h-stock\" hidden>\n        <h2 id=\"h-stock\">Carpet stock (staff only)</h2>\n        <p class=\"sub\">Untick a colour to mark it out of stock. Customers see it greyed out straight away, for every series that uses that carpet. Only you and editors see this panel.</p>\n        <div id=\"stockList\"></div>\n        <div class=\"saving\" id=\"stockMsg\" aria-live=\"polite\"></div>\n      </section>\n    </main>\n\n    <aside>\n      <div class=\"preview\" aria-label=\"Bag preview\">\n        <div class=\"face-tabs\" role=\"tablist\" aria-label=\"Bag side\">\n          <button type=\"button\" role=\"tab\" id=\"tabFast\" aria-selected=\"true\" aria-controls=\"printFace\">Fast side</button>\n          <button type=\"button\" role=\"tab\" id=\"tabSlow\" aria-selected=\"false\" aria-controls=\"carpetFace\">Slow side</button>\n        </div>\n        <div class=\"face\">\n          <div class=\"bag print\" id=\"printFace\" role=\"tabpanel\" aria-labelledby=\"tabFast\"></div>\n          <div class=\"bag carpet\" id=\"carpetFace\" role=\"tabpanel\" aria-labelledby=\"tabSlow\" hidden></div>\n          <div class=\"fn\" id=\"faceName\">Your design</div>\n        </div>\n      </div>\n\n      <div class=\"ticket\" aria-live=\"polite\">\n        <h3 id=\"summaryTitle\">Your order</h3>\n        <dl id=\"summary\"></dl>\n        <div class=\"order-list\" id=\"orderList\"></div>\n        <a class=\"btn\" id=\"cartBtn\" href=\"#\" target=\"_blank\" rel=\"noopener\">Add to cart</a>\n        <div class=\"cart-err\" id=\"cartErr\" role=\"alert\" hidden></div>\n        <div class=\"missing\">Your design reference <b id=\"refOut\"></b> goes with the order. <span id=\"checkoutNote\">Check out on brotherhoodcornhole.com.</span></div>\n        <div class=\"missing\" id=\"savedNote\" hidden>Your design is saved on this device. <button type=\"button\" class=\"linkish\" id=\"startOver\">Start over</button></div>\n        <button type=\"button\" class=\"share-btn\" id=\"shareBtn\">Share this design</button>\n        <div class=\"share-box\" id=\"shareBox\" hidden>\n          <input type=\"text\" id=\"shareUrl\" readonly aria-label=\"Link to this design\">\n          <p id=\"shareMsg\"></p>\n        </div>\n      </div>\n    </aside>\n  </div>\n";

// ---- Where the page runs. On brotherhoodcornhole.com the Liquid template sets window.DS_SHOP
// (asset URLs, live prices, carpet stock, sign-in state); in the claude.ai prototype it's
// absent and everything falls back to the values below and relative file paths.
const SHOP = window.DS_SHOP || null;
const asset = p => (SHOP && SHOP.assets && SHOP.assets[p]) || p;

// Series lineup and carpet per series: BC Print Bridge inventory.py + Design Helper
// carpet_map.py / products.json (2026-09-29). White label + Dragon Bags excluded.
// Speed = [slow, fast] on a 1-10 scale, and carpet / non-carpet slow side, from the
// master speed charts (ACL Pro/Comp 2027 and ACO Approved), confirmed 2026-09-29.
// Fabric names, fill weights and SKU variants are deliberately NOT shown to customers.
const SERIES = [
  {p:"GUA", name:"Guardian",   prog:"Pro",  carpet:"CADID",     speed:[5,8]},
  {p:"GUAX",name:"Guardian X", prog:"Pro",  carpet:"CADID",     speed:[5,9]},
  {p:"COD", name:"Code 3",     prog:"Pro",  carpet:"VIEWMONT",  speed:[5.5,9]},
  {p:"MAC", name:"Mach 3",     prog:"Pro",  carpet:"OSPREY",    speed:[6,9]},
  {p:"RAN", name:"Ranger",     prog:"Pro",  carpet:"BUGLE",     speed:[6,8]},
  {p:"SEN", name:"Sentry",     prog:"Pro",  carpet:"RUMBA",     speed:[4,9]},
  {p:"VAL", name:"Valor",      prog:"Pro",  carpet:"ANCHORAGE", speed:[5,9]},
  {p:"WIN", name:"Wingman",    prog:"Pro",  carpet:"ANCHORAGE", speed:[5,8]},
  {p:"BED", name:"Bedlam",     prog:"Comp", carpet:"RUMBA",     speed:[4,7]},
  {p:"HER", name:"Hero",       prog:"Comp", carpet:"VIEWMONT",  speed:[5.5,9]},
  {p:"RED", name:"Redline",    prog:"Comp", carpet:"TUI",       speed:[6,9]},
  {p:"SCO", name:"Scout",      prog:"Comp", carpet:"CADID",     speed:[5,6]},
  {p:"STE", name:"Steel Rain", prog:"Comp", carpet:"EMBRE",     speed:[5,8]},
  {p:"WAR", name:"Warthog",    prog:"Comp", carpet:"CADID",     speed:[5,8]},
  {p:"AFT", name:"Afterburner",prog:"ACO",  carpet:"OSPREY",    speed:[6,9]},   // = Mach 3
  {p:"BAS", name:"Bastion",    prog:"ACO",  carpet:"CADID",     speed:[5,8]},   // = Guardian
  {p:"BASX",name:"Bastion X",  prog:"ACO",  carpet:"CADID",     speed:[5,9]},   // = Guardian X
  {p:"DIS", name:"Dispatch",   prog:"ACO",  carpet:"VIEWMONT",  speed:[5.5,9]}, // = Code 3
  {p:"PAT", name:"Pathfinder", prog:"ACO",  carpet:"BUGLE",     speed:[6,8]},   // = Ranger
  {p:"OVE", name:"Overwatch",  prog:"ACO",  carpet:"ANCHORAGE", speed:[5,8]},   // = Wingman
];

// Programs shown to customers. ACO launched 2026-09-30 (one weight, like the live ACO listings).
const PROGRAMS = ["Pro","Comp","ACO"];

// Series sold in Light / Regular / Heavy (Product Library + Shopify Custom listings).
// Mach 3 and all Comp bags are one weight. Only the names are shown, never grams.
const SIZED = new Set(["GUA","GUAX","COD","RAN","SEN","VAL","WIN"]);
const WEIGHTS = [["L","Light"],["R","Regular"],["H","Heavy"]];

const NON_CARPET = new Set(["MAC","RED","STE","AFT"]);

// Carpet colours: names/codes are the Print Bridge / carpet_map lists (unchanged).
// img = the carpet texture exported from the "Right artwork" smart object of the
// matching Design Helper\Fabric Types file (600px sRGB), published under fabric/. null = no file with that name yet, so the
// swatch falls back to the hex estimate. [code, name, hex, img]
const COLORS = {
  CADID:[["BLK","Black","#2B2B2B","cadid-black"],["MID","Midnight","#364152","cadid-midnight"],["PEP","Pepper","#5C5C5C","cadid-pepper"],
         ["PCH","Parchment","#D6D0CE","cadid-white"],["POP","Poppy","#86311F","cadid-red"]],
         // Silver discontinued (user, 2026-09-29).
  ANCHORAGE:[["PNK","Pink","#D37E91","anchorage-pink"],["NVY","Navy Blue","#294A65","anchorage-navy"],["ORG","Orange","#CD5129","anchorage-orange"],
         ["AQA","Aqua","#95BEC4","anchorage-aqua"],["WHT","White","#CBCBCB","anchorage-white"],["TRQ","Turquoise","#5C92AD","anchorage-turqoise"],
         ["BLK","Black","#363636","anchorage-black"],["RVR","River Rock","#ABAFAE","anchorage-river-rock"],["SLT","Slate","#868686","anchorage-slate"],
         ["RED","Red","#9D2D27","anchorage-red"],["LLY","Lilly","#83AD95","anchorage-lilly"],["SHD","Shadow","#2D3D52","anchorage-shadow"]],
  VIEWMONT:[["RED","Red","#852D1E","viewmont-red"],["IND","Indigo","#394355","viewmont-indigo"],["GRN","Green","#9F9F60","viewmont-green"],
         ["WHT","White","#DFDFDF","viewmont-white"],["LGR","Light Gray","#9A9A9A","viewmont-light-gray"],["DNM","Denim","#6B7D8F","viewmont-denim"],
         ["CHR","Charcoal","#6A6664","viewmont-carbon"],["GLD","Gold","#BE995A","viewmont-gold"]],
  // Bugle Graphite / Cement / Granite hidden until they have fabric files (user, 2026-09-29).
  BUGLE:[["MCA","Mica","#534D49","bugle-gray"]],
  RUMBA:[["RED","Red","#8D312B","rumba-red"],["BLK","Black","#4B464C","rumba-carbon"],["BLU","Blue","#3A4153","rumba-blue"],["WHT","White","#C8C5C0","rumba-white"]],
};
const imgUrl = f => asset(`fabric/${f}.jpg`);
const SINGLE = {OSPREY:"#d8d9d5", TUI:"#2b2b2c", EMBRE:"#55524e"};

// Dual-sided print bags (the non-carpet ones) have a PRINTED slow side, so the
// customer picks from preset print colours instead of carpet colours.
// The 12 most common team/uniform colours. Hex values are the published sRGB
// values of the standard athletic Pantone for each colour; the Pantone is the
// reference to check proofs against. [code, name, hex, pantone]
const PRINT_COLORS = [
  ["P-BLK","Black",        "#101820","Black 6 C"],
  ["P-WHT","White",        "#FFFFFF","White (no ink)"],
  ["P-SLV","Silver Gray",  "#A2AAAD","429 C"],
  ["P-RED","Red",          "#C8102E","186 C"],
  ["P-MAR","Maroon",       "#862633","202 C"],
  ["P-ORG","Orange",       "#FF671F","165 C"],
  ["P-GLD","Athletic Gold","#FFC72C","123 C"],
  ["P-KGR","Kelly Green",  "#00843D","348 C"],
  ["P-ROY","Royal Blue",   "#0033A0","286 C"],
  ["P-NVY","Navy",         "#041E42","282 C"],
  ["P-PUR","Purple",       "#582C83","268 C"],
  ["P-PNK","Pink",         "#DA1884","219 C"],
];

const SAMPLE_ART = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="#1f2f57"/><circle cx="100" cy="100" r="70" fill="none" stroke="#e8b54a" stroke-width="6"/><text x="100" y="92" text-anchor="middle" font-family="Big Shoulders Display,Impact,sans-serif" font-weight="900" font-size="34" fill="#ffffff">RIVERSIDE</text><text x="100" y="128" text-anchor="middle" font-family="Big Shoulders Display,Impact,sans-serif" font-weight="700" font-size="22" fill="#e8b54a">CORNHOLE CLUB</text><text x="100" y="186" text-anchor="middle" font-family="monospace" font-size="9" fill="#ffffff" opacity=".6">SAMPLE DESIGN</text></svg>`;

const state = {program:"Pro", series:"GUA", size:"R", color:"BLK", qty:1,
  step:1,                              // furthest step unlocked (1-5); later steps are greyed out (user, 2026-10-06)
  images:[], sel:null,                 // customer images: {id,name,url,x,y,w,ar,px,sample}
  concepts:[],                         // concept artwork for the designer only, never on the bag: {id,name,file,url,img}
  spots:{acl:null, bc:null},           // which logo sits in which spot; customers place both
  ink:"#1F1D1E",                       // one colour for the BC logo, series title and custom text
  font:null,                           // customer's uploaded font {name, family}, or null = ours
  kind:"new", reorderOf:"", reorderOk:false,   // "reorder" = reprint a past design at the standard price
  rightsOk:false,                              // customer confirmed they may use the images they added
  reorderPick:null,                            // the past order picked from their account, if any
  manualReorder:false};                        // they chose to type an order number instead

// ---- Bag template geometry (Master Bag Template, 2026-09-29). All in % of the 7.25 in square.
const BAG_IN = 7.25;
const SPOTS = [ // centres of the six 1.4 x 0.83 in spots in "Bag Stamp & Logo Positions.ai"
  {id:"TL", label:"Top left",      x:23.45, y:21.17},
  {id:"TC", label:"Top centre",    x:50.07, y:16.21},
  {id:"TR", label:"Top right",     x:76.97, y:21.17},
  {id:"BL", label:"Bottom left",   x:23.31, y:78.55},
  {id:"BC", label:"Bottom centre", x:50.07, y:83.79},
  {id:"BR", label:"Bottom right",  x:76.83, y:78.55},
];
// Logo artwork exported from the template's logo files, at their real size (inches wide).
const LOGOS = {
  // h = art height in inches (the PNGs are cropped tight to the art), used to keep each one inside the safe area.
  // ACL stamps include the white outline added 2026-09-30 so they show on dark bags.
  pro:  {src:asset("stamps/acl-pro-logo.png"),              w:1.235, name:"ACL Pro 2027 stamp", h:0.658},
  comp: {src:asset("stamps/acl-comp-logo.png"),             w:1.312, name:"ACL Comp 2027 stamp", h:0.628},
  // Always printed at its full 1.5 in (user, 2026-09-30). PNG cropped to the visible art: 1.5 x 0.968 in.
  aco:  {src:asset("stamps/aco-approved-logo.png"),         w:1.5,   name:"ACO Approved stamp", h:0.968},
  // Printed 1.0 in wide (0.83 in tall = the spot height), not its 1.5 in file size (user, 2026-09-30).
  bc:   {src:asset("stamps/brotherhood-cornhole-logo.png"), w:1.0,   name:"Brotherhood logo", h:0.826},
};
// Exact paths from the locked "Template" layer of Bag Stamp & Logo Positions.ai (inches, artboard
// top-left, y down), read via Illustrator on 2026-09-29. Drawn over the design, never printed.
const TMPL = {
  cut:  "M5.7522 7.25C5.7522 7.25 1.4978 7.25 1.4978 7.25C0.6706 7.25 0 6.5794 0 5.7522C0 5.7522 0 1.4978 0 1.4978C0 0.6706 0.6706 0 1.4978 0C1.4978 0 5.7522 0 5.7522 0C6.5794 0 7.25 0.6706 7.25 1.4978C7.25 1.4978 7.25 5.7522 7.25 5.7522C7.25 6.5794 6.5794 7.25 5.7522 7.25Z",
  seam: "M5.2588 6.7625C5.2588 6.7625 1.9912 6.7625 1.9912 6.7625C1.1607 6.7625 0.4875 6.0893 0.4875 5.2588C0.4875 5.2588 0.4875 1.9912 0.4875 1.9912C0.4875 1.1607 1.1607 0.4875 1.9912 0.4875C1.9912 0.4875 5.2588 0.4875 5.2588 0.4875C6.0893 0.4875 6.7625 1.1607 6.7625 1.9912C6.7625 1.9912 6.7625 5.2588 6.7625 5.2588C6.7625 6.0893 6.0893 6.7625 5.2588 6.7625Z",
  safe: "M4.9984 6.5C4.9984 6.5 2.2516 6.5 2.2516 6.5C1.4223 6.5 0.75 5.8277 0.75 4.9984C0.75 4.9984 0.75 2.2516 0.75 2.2516C0.75 1.4223 1.4223 0.75 2.2516 0.75C2.2516 0.75 4.9983 0.75 4.9983 0.75C5.8277 0.75 6.5 1.4223 6.5 2.2517C6.5 2.2517 6.5 4.9984 6.5 4.9984C6.5 5.8277 5.8277 6.5 4.9984 6.5Z",
};
const TEMPLATE_SVG = `<svg class="tmpl" viewBox="0 0 7.25 7.25" aria-hidden="true">
  <path d="${TMPL.cut} ${TMPL.seam}" fill="rgba(0,0,0,.14)" fill-rule="evenodd"/>
  <path d="${TMPL.seam}" fill="none" stroke="#00a3d9" stroke-width="1.25" vector-effect="non-scaling-stroke"/>
  <path d="${TMPL.safe}" fill="none" stroke="#00a3d9" stroke-width="1.25" stroke-dasharray="6 4" vector-effect="non-scaling-stroke"/>
  <path d="${TMPL.cut}" fill="none" stroke="#111" stroke-width="0.0556"/>
</svg>`;  // cut stroke: the file's 2 pt line; drawn 2x because the outer half is clipped by the bag edge
const CUT_SVG = `<svg class="tmpl" viewBox="0 0 7.25 7.25" aria-hidden="true"><path d="${TMPL.cut}" fill="none" stroke="#111" stroke-width="0.0556"/></svg>`;
const aclKind = s => s.prog === "Comp" ? "comp" : s.prog === "ACO" ? "aco" : "pro";
const stampLabel = s => s.prog === "ACO" ? "ACO stamp" : "ACL stamp";
const spotById = id => SPOTS.find(p => p.id === id);
// Stamps and our logo are nudged toward the bag centre until their outline sits inside the safe
// area (user, 2026-09-30: the Brotherhood logo poked outside it in the corner spots). Outline =
// points on the art's edge, in inches from its centre. The ACO stamp uses its real shape
// (shield top + shoulders, check-mark tip, APPROVED band corners); the others their tight box.
const ACO_EDGE = [[319,0],[154,44],[484,44],[122,209],[0,309],[648,309],[0,418],[648,418]]
  .map(([x,y]) => [x/432 - 0.75, y/432 - 0.484]);
function inSafe(x, y){   // the safe-area rounded square: inset 0.75 in, corner radius 1.5016 in
  const r = 1.5016, lo = 0.75 + r, hi = BAG_IN - 0.75 - r;
  return Math.hypot(x - Math.min(Math.max(x, lo), hi), y - Math.min(Math.max(y, lo), hi)) <= r + 1e-9;
}
// Where a stamp's centre goes for a spot, in %. Only the ACO stamp ever moves off the spot centre.
const boxEdge = (w, h) => [-1, 0, 1].flatMap(sx => [-1, 0, 1].map(sy => [sx * w / 2, sy * h / 2])).filter(([a, b]) => a || b);
function stampAt(kind, id){
  const p = spotById(id), L = LOGOS[kind];
  const edge = kind === "aco" ? ACO_EDGE : (L && L.h ? boxEdge(L.w, L.h) : null);
  if(!edge) return {x:p.x, y:p.y};
  let x = p.x / 100 * BAG_IN, y = p.y / 100 * BAG_IN;
  const c = BAG_IN / 2, d = Math.hypot(c - x, c - y), dx = (c - x) / d, dy = (c - y) / d;
  for(let n = 0; n < 400 && !edge.every(([a,b]) => inSafe(x + a, y + b)); n++){ x += dx * .01; y += dy * .01; }
  return {x: x / BAG_IN * 100, y: y / BAG_IN * 100};
}
const pct2in = p => Math.round(p / 100 * BAG_IN * 100) / 100;
const weightText = s => SIZED.has(s.p) ? WEIGHTS.find(w=>w[0]===state.size)[1] : "Standard (one weight)";
const $ = id => document.getElementById(id);
const series = () => SERIES.find(s=>s.p===state.series);
const esc = t => String(t).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
// Printed slow side: every non-carpet bag (Mach 3, Redline, Steel Rain, Afterburner)
// gets the preset print colours. The library's Mach Steel colours are deliberately
// NOT offered (user decision 2026-09-29).
const printed = s => NON_CARPET.has(s.p);
const colorLabel = (s,c) => c[1];
// Carpet stock. Keys are "FABRIC:CODE" (e.g. "CADID:POP"), so a colour is out for every
// series that uses that fabric. Lives in the page's db at settings/stock, written only by
// the owner/editors from the staff panel below; printed colours are never out of stock.
state.out = new Set();
const stockKey = (fabric, code) => `${fabric}:${code}`;
const isOut = (s, code) => !printed(s) && state.out.has(stockKey(s.carpet, code));
const optionsFor = s => printed(s) ? PRINT_COLORS : COLORS[s.carpet];
const colorOf = s => optionsFor(s)?.find(c=>c[0]===state.color);
const swatchHex = s => optionsFor(s) ? (colorOf(s)||optionsFor(s)[0])[2] : SINGLE[s.carpet];
const speedText = s => s.speed ? `${s.speed[0]} slow / ${s.speed[1]} fast` : "Rating coming soon";

function bar(val, cls){
  let h = "";
  for(let i=1;i<=10;i++){ const on = val>=i, half = !on && val>i-1; h += `<i class="${on?"on":half?"half":""}"></i>`; }
  return `<span class="bar ${cls}" aria-hidden="true">${h}</span>`;
}
function speedMeter(s){
  if(!s.speed) return `<span class="speed"><span class="tbd">Speed rating coming soon</span></span>`;
  const [sl,fa]=s.speed;
  return `<span class="speed" role="img" aria-label="Slow side ${sl} of 10, fast side ${fa} of 10">
    <span class="k">Slow</span>${bar(sl,"slow")}<span class="v">${sl}</span>
    <span class="k">Fast</span>${bar(fa,"fast")}<span class="v">${fa}</span></span>`;
}

function radioKeys(container, selector){
  container.addEventListener("keydown", e=>{
    if(!["ArrowRight","ArrowDown","ArrowLeft","ArrowUp"].includes(e.key)) return;
    const items=[...container.querySelectorAll(selector)];
    const i=items.indexOf(document.activeElement); if(i<0) return;
    e.preventDefault();
    const n=items[(i+(e.key==="ArrowRight"||e.key==="ArrowDown"?1:-1)+items.length)%items.length];
    n.focus(); n.click();
  });
}

function renderPrograms(){
  $("programTabs").innerHTML = PROGRAMS.map(p=>
    `<button type="button" class="tab" aria-pressed="${p===state.program}" data-p="${p}">${p}</button>`).join("");
}
function renderSeries(){
  const list = SERIES.filter(s=>s.prog===state.program);
  const anyOn = picked(1) && list.some(x=>x.p===state.series);
  $("seriesCards").innerHTML = list.map((s,i)=>{
    const on = picked(1) && s.p===state.series;
    return `<button type="button" class="card" role="radio" aria-checked="${on}" tabindex="${on||(!anyOn&&i===0)?0:-1}" data-s="${s.p}">
      <span class="nm">${esc(s.name)}</span>${speedMeter(s)}
      <span class="kind">${NON_CARPET.has(s.p)?"Non-carpet":"Carpet"} slow side</span></button>`;}).join("");
}
function renderWeight(){
  const s = series();
  if(SIZED.has(s.p)){
    $("weightSub").textContent = `${s.name} comes in three weights. Regular is our standard.`;
    $("weightBox").innerHTML = `<div class="seg" role="radiogroup" aria-labelledby="h-weight">${WEIGHTS.map(([k,n],i)=>{
      const on=picked(2) && k===state.size;
      return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on||(!picked(2)&&i===0)?0:-1}" data-w="${k}">${n}</button>`;}).join("")}</div>`;
  } else {
    $("weightSub").textContent = `${s.name} comes in one standard weight, so there's nothing to choose.`;
    $("weightBox").innerHTML = "";
  }
}
function renderCarpet(){
  const s = series(), opts = optionsFor(s);
  if(opts){
    const inStock = opts.filter(c => !isOut(s, c[0]));
    if(!inStock.some(c=>c[0]===state.color)) state.color = inStock.length ? inStock[0][0] : null;
    $("carpetSub").textContent = !inStock.length
      ? `Every ${s.name} slow side colour is out of stock right now. Check back soon.`
      : printed(s)
      ? `The ${s.name} is printed on both sides. Pick a solid colour for the slow side.`
      : opts.length === 1
        ? `The ${s.name} slow side comes in ${opts[0][1]}.`
        : `The ${s.name} slow side comes in ${opts.length} colours${inStock.length < opts.length ? `, ${inStock.length} in stock right now` : ""}.`;
    $("carpetBox").innerHTML = `<div class="swatches" role="radiogroup" aria-label="Slow side colour">${opts.map(([c,n,h,x])=>{
      const img = printed(s) ? null : x;  // print colours carry a Pantone in slot 3, not an image
      const on=picked(3) && c===state.color, out = isOut(s, c);
      const bg = img ? `background:${h} url('${imgUrl(img)}') center/cover` : `background-color:${h}`;
      return `<button type="button" class="sw${out?" out":""}" role="radio" aria-checked="${on}" tabindex="${on||(!picked(3)&&c===inStock[0]?.[0])?0:-1}" data-c="${c}" ${out?`disabled aria-label="${esc(n)}, out of stock"`:""}><i class="${img?"photo":""}" style="${bg}"></i><span class="cn">${esc(n)}</span>${out?`<span class="oos">Out of stock</span>`:""}</button>`;}).join("")}</div>`;
  } else {
    state.color = null;
    $("carpetSub").textContent = `The ${s.name} slow side comes in one colour.`;
    $("carpetBox").innerHTML = `<div class="single"><i style="background:${SINGLE[s.carpet]}"></i><div><b>Standard colour</b><br><span style="color:var(--muted);font-size:13px">Nothing to choose here. Move on to your artwork.</span></div></div>`;
  }
}
function renderPreview(){
  const s = series();
  if(typeof syncMock === "function") syncMock();
  drawBag($("printFace"), false);
  const cf = $("carpetFace"), cimg = printed(s) ? null : colorOf(s)?.[3];
  cf.style.backgroundColor = swatchHex(s);
  cf.style.backgroundImage = cimg ? `url('${imgUrl(cimg)}')` : "";
  cf.style.backgroundSize = cimg ? "cover" : "";
  cf.style.backgroundPosition = cimg ? "center" : "";
  cf.classList.toggle("carpet", !printed(s) && !cimg);
  cf.classList.toggle("photo", !!cimg);
  const c = colorOf(s);
  const slowName = c ? colorLabel(s,c) : optionsFor(s) ? "Out of stock" : "Standard colour";
  $("faceName").textContent = state.face === "slow" ? `Slow side · ${slowName}` : "Fast side · Your design";
}
function renderSummary(){
  syncStep(); applySteps();
  const s = series(), c = colorOf(s), many = designs.length > 1;
  const rows = [
    ["Bag", picked(1) ? s.name : "Not picked yet"],
    ["Speed", picked(1) ? speedText(s) : "–"],
    ["Weight", picked(2) ? weightText(s) : "–"],
    ["Slow side", !picked(3) ? "–" : c ? colorLabel(s,c) : optionsFor(s) ? "Out of stock" : "Standard colour"],
    ["Quantity", `${state.qty} set${state.qty>1?"s":""} · ${state.qty*4} bags`],
    ["Price", `${money(priceOf(s))} / set${isReorder() ? " (reorder)" : ""}`],
  ];
  if(isReorder()) rows.unshift(["Type", `Reorder of ${state.reorderOf.trim() || "…"}`]);
  if(!many) rows.push(["Total", money(priceOf(s)*state.qty)]);
  $("summaryTitle").textContent = many ? `Bag ${cur+1} of ${designs.length}` : "Your order";
  $("summary").innerHTML = rows.map(([k,v])=>`<dt>${k}</dt><dd>${esc(v)}</dd>`).join("");
  $("qEq").textContent = `set${state.qty>1?"s":""} = ${state.qty*4} bags`;
  $("refOut").textContent = many ? `${REF}-1 to -${designs.length}` : `${REF}-1`;

  // Whole order: every bag design, its subtotal, the grand total.
  saveCurrent();
  const info = designs.map((d, i) => withDesign(i, () => {
    const sx = series();
    return {i, name: sx.name, qty: state.qty, prog: sx.prog, sub: priceOf(sx) * state.qty, reorder: isReorder(),
            miss: needs(), soldOut: !!optionsFor(sx) && !state.color, step: isReorder() ? 5 : state.step};
  }));
  const total = info.reduce((a, d) => a + d.sub, 0);
  $("orderList").innerHTML = many ? info.map(d =>
    `<div class="ol-row"><span>${d.i+1}. ${d.reorder ? "Reorder · " : ""}${esc(d.name)} × ${d.qty} set${d.qty>1?"s":""}</span><span>${money(d.sub)}</span></div>`).join("")
    + `<div class="ol-row ol-total"><span>Order total</span><span>${money(total)}</span></div>` : "";
  renderBagTabs(info);

  // Soft lock (spec): every bag needs its stamp, logo and series title; nothing sold out.
  const blocked = info.find(d => d.soldOut || d.miss.length);
  const cb = $("cartBtn");
  if(blocked){
    cb.removeAttribute("href"); cb.setAttribute("aria-disabled","true"); cb.classList.add("off");
    const who = many ? `Bag ${blocked.i+1} (${blocked.name}): ` : "";
    cb.textContent = blocked.soldOut ? `${who}slow side colours out of stock`
      : blocked.step < 4 ? `${who}finish step ${blocked.step} to continue` : `${who}add ${listWords(blocked.miss)} to continue`;
  } else {
    cb.href = SHOP ? SHOP.root + "cart" : cartUrl(); cb.removeAttribute("aria-disabled"); cb.classList.remove("off");
    cb.textContent = `${SHOP && !SHOP.customer ? "Sign in & add to cart" : "Add to cart"} · ${money(total)}`;
  }
  scheduleSave();
}

// ---- Multiple bag designs in one order (spec: each with its own design and proof thread).
// The editor always works on `state`; the other designs wait in `designs` and swap in.
const DESIGN_FIELDS = ["program","series","size","color","qty","step","concepts","images","sel","spots","ink","font","face","kind","reorderOf","reorderOk","missingFont","rightsOk","reorderPick","manualReorder"];
let designs = [], cur = 0;
function saveCurrent(){
  const d = designs[cur] || (designs[cur] = {});
  for(const k of DESIGN_FIELDS) d[k] = state[k];
  d.notes = $("notes").value;
}
function loadInto(d){ for(const k of DESIGN_FIELDS) state[k] = d[k]; }
// Run fn with design i swapped into `state`, then put the current one back (no rendering).
function withDesign(i, fn){
  if(i === cur) return fn();
  const back = {}; for(const k of DESIGN_FIELDS) back[k] = state[k];
  const keepCur = cur; loadInto(designs[i]); cur = i;
  try { return fn(); } finally { cur = keepCur; loadInto(back); }
}
const designRef = () => `${REF}-${cur + 1}`;
function newDesign(){
  return {program: state.program, series: state.series, size: "R", color: null, qty: 1, step: 1, concepts: [], images: [], sel: null,
          spots: {acl: null, bc: null}, ink: "#1F1D1E", font: null, face: "fast", notes: "",
          kind: "new", reorderOf: "", reorderOk: false, missingFont: null, rightsOk: false, reorderPick: null, manualReorder: false};
}
function switchTo(i){ saveCurrent(); showDesign(i); }
// Load design i into the editor WITHOUT saving the current one first (used after a removal).
function showDesign(i){
  cur = i; loadInto(designs[i]);
  $("notes").value = designs[i].notes || ""; $("qty").value = state.qty;
  const [r, g, b] = [1,3,5].map(k => parseInt(state.ink.slice(k, k+2), 16));
  Object.assign(ink, rgb2hsv(r, g, b)); setInk(state.ink, false);
  $("fontReset").hidden = !state.font;
  showFontMsg();
  artNote("");
  if(typeof showFace === "function"){ const f = state.face; state.face = null; showFace(f || "fast"); }
  render();
  $("bagTabs").querySelector(`[data-bag="${i}"]`)?.focus();
}
function renderBagTabs(info){
  $("bagTabs").innerHTML = info.map(d => {
    const ok = !d.miss.length && !d.soldOut, on = d.i === cur;
    return `<span class="bag-tab" role="tab" aria-selected="${on}">
      <span class="dot${ok?" ok":""}" title="${ok?"Ready":"Still needs items"}"></span>
      <button type="button" class="go" data-bag="${d.i}">${d.i+1} · ${d.reorder ? "Reorder · " : ""}${esc(d.name)} · ${d.qty} set${d.qty>1?"s":""}</button>
      ${info.length > 1 ? `<button type="button" class="x" data-drop="${d.i}" aria-label="Remove bag ${d.i+1}">×</button>` : ""}</span>`;
  }).join("");
}
$("bagTabs").addEventListener("click", e => {
  const drop = e.target.closest("[data-drop]");
  if(drop){
    const i = +drop.dataset.drop; saveCurrent();
    designs.splice(i, 1);
    // Keep viewing the same bag if another one was removed; otherwise show its neighbour.
    const next = i < cur ? cur - 1 : i === cur ? Math.min(i, designs.length - 1) : cur;
    showDesign(next);
    return;
  }
  const go = e.target.closest("[data-bag]");
  if(go && +go.dataset.bag !== cur) switchTo(+go.dataset.bag);
});
$("addBag").addEventListener("click", () => {
  saveCurrent();
  designs.push(newDesign());
  switchTo(designs.length - 1);
  document.querySelector(".bags-bar").scrollIntoView({behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start"});
});

// ---- Shopify checkout. One product, "Design Studio Custom" (draft until you activate it),
// with a Pro and a Comp variant. The design choices travel as the order note plus
// cart attributes, keyed by a Design Studio reference the designer portal can match on.
const STORE = "https://www.brotherhoodcornhole.com";
const PRODUCT = {
  Pro:  {variant:"49662972657902", price:135},
  Comp: {variant:"49662972690670", price:85},
  ACO:  {variant:"49669053841646", price:115},
};
// Reorders: "Design Studio Reorder" (draft until activated), standard bag prices, no design fee.
// Not tagged "Design Studio", so Shopify Flow/ApprovePro skip it: the design was already proofed.
const REORDER = {
  Pro:  {variant:"49669020483822", price:109.99},
  Comp: {variant:"49669020516590", price:59.99},
  ACO:  {variant:"49669053907182", price:89.99},
};
// On the website, prices come live from Shopify (by variant id), so a price change there shows here.
if(SHOP && SHOP.prices) for(const t of [PRODUCT, REORDER]) for(const k in t){
  const p = SHOP.prices[t[k].variant]; if(typeof p === "number") t[k].price = p;
}
const isReorder = () => state.kind === "reorder";
const productOf = s => (isReorder() ? REORDER : PRODUCT)[s.prog];
const priceOf = s => productOf(s).price;
// What this bag still needs before it can be ordered (new design: stamp/logo/title; reorder: its original).
function needs(){
  if(!isReorder()) return missingElements();
  const m = [], p = state.reorderPick;
  if(p){                  // picked from their account: the bag and weight must stay as on the original
    if(state.series !== p.series || (p.size && state.size !== p.size)) m.push(`the original bag and weight (${p.label})`);
    return m;
  }
  const typing = !(SHOP && SHOP.customer && PAST.length) || state.manualReorder || !!state.reorderOf.trim();
  if(!typing){ m.push("your past design from the list"); return m; }
  if(!state.reorderOf.trim()) m.push("the original order number");
  if(!state.reorderOk) m.push("confirmation that the bag and weight match");
  return m;
}
const money = n => "$" + n.toFixed(2);
function newRef(){ // e.g. DS-7KQ4MX; no 0/O/1/I to avoid misreading
  const a="23456789ABCDEFGHJKLMNPQRSTUVWXYZ", b=new Uint32Array(6);
  (window.crypto||window.msCrypto).getRandomValues(b);
  return "DS-"+[...b].map(x=>a[x%a.length]).join("");
}
let REF = newRef();   // replaced by the saved design's reference when one is restored
// One design's details (the design currently in `state`). Keys are prefixed "Bag N - "
// on the order so the Design Desk can split an order back into its designs.
function designLines(){
  const s=series(), c=colorOf(s);
  if(isReorder()) return {
    "Ref": designRef(),
    "Type": "Reorder (no design fee)",
    "Reorder of": state.reorderOf.trim(),
    "Reorder picked from": state.reorderPick ? `Customer's account (${state.reorderPick.order || state.reorderPick.ref}, ${state.reorderPick.label})` : "Typed in by the customer",
    "Bag": `${s.name} (${s.prog})`,
    "Weight": weightText(s),
    "Slow side": c ? `${colorLabel(s,c)}${printed(s)?" (printed)":""}` : "Standard colour",
    "Sets": `${state.qty} (${state.qty*4} bags)`,
    "Design notes": ((designs[cur] && designs[cur].notes) || "").trim() || "-",
  };
  return {
    "Type": "New design",
    "Ref": designRef(),
    "Bag": `${s.name} (${s.prog})`,
    "Weight": weightText(s),
    "Slow side": c ? `${colorLabel(s,c)}${printed(s)?" (printed)":""}` : "Standard colour",
    "Sets": `${state.qty} (${state.qty*4} bags)`,
    "Stamp": `${LOGOS[aclKind(s)].name}, ${state.spots.acl ? spotById(state.spots.acl).label : "not placed"}`,
    "Brotherhood logo": state.spots.bc ? spotById(state.spots.bc).label : "not placed",
    "Series title": state.images.some(im => im.kind === "title") ? s.name : "not placed",
    "Your text": textSummary(),
    "Logo & text colour": state.ink,
    "Font": state.font ? `${state.font.name} (customer's file, to be sent)` : "Our default",
    "Artwork": artworkSummary(),
    "Concept artwork": state.concepts.length ? `${state.concepts.map(c => c.name).join("; ")} (reference only, not printed)` : "None",
    "Artwork rights": hasOwnImages() ? "Customer confirmed they own or may use their images, and none is a team, brand or character logo" : "No customer images",
    "Design notes": ((designs[cur] && designs[cur].notes) || "").trim() || "-",
    "Design spec": designSpec(),
  };
}
function orderLines(){
  saveCurrent();
  const out = {"Design Studio Ref": REF, "Bags": String(designs.length)};
  designs.forEach((d, i) => withDesign(i, () => {
    for(const [k, v] of Object.entries(designLines())) out[`Bag ${i+1} - ${k}`] = v;   // plain ASCII: Shopify attribute names
  }));
  return out;
}
// A short, readable note (full details ride in the attributes, which Shopify shows on the order).
function orderNote(){
  const note = [`Design Studio order ${REF}: ${designs.length} bag design${designs.length>1?"s":""}`];
  designs.forEach((d, i) => withDesign(i, () => {
    const s = series(), c = colorOf(s);
    note.push(`${designRef()}: ${isReorder() ? `REORDER of ${state.reorderOf.trim()} - ` : ""}${s.name} ${weightText(s)}, ${c ? c[1] : "standard"} slow side, ${state.qty} set${state.qty>1?"s":""}`);
  }));
  return note.join("\n");
}
// claude.ai prototype: a cart permalink (no file uploads possible there).
function cartUrl(){
  const o = orderLines(), p = new URLSearchParams(), qty = {};
  designs.forEach((d, i) => withDesign(i, () => {
    const v = productOf(series()).variant;
    qty[v] = (qty[v] || 0) + state.qty;
  }));
  p.set("note", orderNote());
  for(const [k,v] of Object.entries(o)) p.set(`attributes[${k}]`, v);
  const items = Object.entries(qty).map(([v, q]) => `${v}:${q}`).join(",");   // same variant = one line, summed
  return `${STORE}/cart/${items}?${p.toString()}`;
}
// ---- Step by step (user, 2026-10-06): one section at a time. The current step is highlighted,
// later ones are greyed out and inert until the customer picks something in the current one.
// Steps with nothing to choose (one weight, one colour) are skipped; step 4 is done when its
// required items are placed. Reorders aren't gated: picking the past order sets the bag and weight.
const picked = n => isReorder() || state.step > n;   // has the customer made step n's choice?
function syncStep(){
  if(isReorder()) return;
  const s = series(), opts = optionsFor(s);
  for(;;){
    if(state.step === 2 && !SIZED.has(s.p)) state.step = 3;
    else if(state.step === 3 && (!opts || opts.filter(c => !isOut(s, c[0])).length === 1)) state.step = 4;
    else if(state.step === 4 && !needs().length) state.step = 5;
    else break;
  }
}
// The customer finished step n: open the next one. True if it moved on (so the page can scroll).
function advance(n){
  if(isReorder() || state.step !== n) return false;
  state.step = n + 1; syncStep(); return true;
}
const STEP_SECTIONS = [[1, "h-series"], [2, "h-weight"], [3, "h-carpet"], [4, "h-art"], [4, "h-reorder"], [5, "h-qty"]];
const stepSection = id => document.querySelector(`section[aria-labelledby="${id}"]`);
function applySteps(){
  const free = isReorder();
  for(const [n, id] of STEP_SECTIONS){
    const sec = stepSection(id), locked = !free && n > state.step;
    sec.classList.toggle("locked", locked); sec.inert = locked;
    sec.classList.toggle("current", !free && n === state.step);
  }
}
function scrollToStep(){
  const id = STEP_SECTIONS.find(([n, id]) => n === state.step && !stepSection(id).hidden)?.[1];
  if(!id) return;
  const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  stepSection(id).scrollIntoView({behavior: smooth ? "smooth" : "auto", block: "start"});
}
function render(){ syncStep(); renderKind(); renderPrograms(); renderSeries(); renderWeight(); renderCarpet(); renderDesign(); renderConcepts(); renderPreview(); renderSummary(); }

// New design vs reorder: a reorder skips "Design your bag" and asks for its original instead.
function renderKind(){
  const r = isReorder();
  document.querySelector('section[aria-labelledby="h-art"]').hidden = r;
  $("reorderStep").hidden = !r;
  $("kindLabel").textContent = designs.length > 1 ? `Bag ${cur+1} is` : "This bag is";
  document.querySelectorAll(".kind-switch [data-kind]").forEach(b => b.setAttribute("aria-checked", String(b.dataset.kind === state.kind)));
  if(document.activeElement !== $("reorderOf")) $("reorderOf").value = state.reorderOf;
  $("reorderOk").checked = state.reorderOk;
  if(r) renderPastPick();
  $("faceName") && (document.querySelector('.face-tabs').hidden = false);
}
document.querySelector(".kind-switch").addEventListener("click", e => {
  const b = e.target.closest("[data-kind]"); if(!b || b.dataset.kind === state.kind) return;
  state.kind = b.dataset.kind; render();
});
$("reorderOf").addEventListener("input", e => {
  state.reorderOf = e.target.value;
  if(state.reorderPick){ state.reorderPick = null; state.reorderOk = false; renderKind(); }   // typed their own: confirm by hand
  renderSummary();
});

// ---- Reorders from the customer's account (spec: "picks the previous design from their account
// history"). The section's Liquid lists the signed-in customer's past custom-bag lines (Design
// Studio lines and the older Custom products) in DS_SHOP.past; picking one fills in the original
// and sets the bag and weight to match it.
const PAST = (() => {
  if(!SHOP || !Array.isArray(SHOP.past)) return [];
  const byLen = SERIES.filter(s => PROGRAMS.includes(s.prog)).sort((a, b) => b.name.length - a.name.length);
  const seen = new Set(), out = [];
  for(const x of SHOP.past){
    if(!x || typeof x !== "object") continue;
    let name = "", weight = "";
    const m = /^(.*?)\s*\((Pro|Comp|ACO)\),\s*(.*)$/.exec(String(x.bag || ""));   // Studio line: "Guardian (Pro), Regular"
    if(m){ name = m[1]; weight = m[3]; }
    else {                                                                             // older "... Custom Code 3 ACL Pro ..." products
      const t = " " + String(x.title || "").toLowerCase().replace(/-/g, " ") + " ";
      const s = byLen.find(z => t.includes(" custom " + z.name.toLowerCase() + " "));
      if(!s) continue;
      name = s.name; weight = x.variant || "";
    }
    const s = SERIES.find(z => z.name.toLowerCase() === name.trim().toLowerCase() && PROGRAMS.includes(z.prog));
    if(!s) continue;
    const w = SIZED.has(s.p) ? WEIGHTS.find(v => new RegExp("^\\s*" + v[1], "i").test(weight)) : null;
    const ref = String(x.reorderOf || x.ref || x.order || "").slice(0, 40);
    const key = `${ref}|${s.p}|${w ? w[0] : ""}`;
    if(!ref || seen.has(key)) continue;
    seen.add(key);
    out.push({ref, order: String(x.order || ""), date: String(x.date || ""), series: s.p, size: w ? w[0] : null,
              label: `${s.name}${w ? ", " + w[1] : ""}`});
  }
  return out;
})();
// Picking from the account is THE way to reorder (user, 2026-09-30); typing an order number is only
// the fallback for orders that aren't on their account (guest checkout, another email).
function renderPastPick(){
  const box = $("pastPick"), p = state.reorderPick;
  $("reorderOkRow").hidden = !!p;
  const manual = !SHOP || (SHOP.customer && !PAST.length) || !!state.manualReorder || (!!state.reorderOf.trim() && !p);
  $("reorderManual").hidden = !manual;
  const fallback = manual ? "" : `<p class="hint"><button type="button" class="linkish" id="showManual">${SHOP && SHOP.customer
    ? "Can't see your order? Enter the order number instead."
    : "Or enter your order number instead."}</button></p>`;
  if(!SHOP){ box.innerHTML = ""; return; }
  if(!SHOP.customer){
    box.innerHTML = `<p class="past-note"><button type="button" class="linkish" id="pastSignIn">Sign in</button> to pick your past design from your account. It sets the right bag and weight for you.</p>` + fallback;
    return;
  }
  if(!PAST.length){
    const n = +SHOP.scanned || 0;
    box.innerHTML = `<p class="past-note">${n ? `We looked through your ${n === 1 ? "past order" : `${n} past orders`} and` : "We"} couldn't find custom bags on your account. Enter your original order number below.</p>`;
    return;
  }
  box.innerHTML = `<p class="lbl" style="margin-top:14px">Pick from your past orders</p>
    <div class="past" role="radiogroup" aria-label="Your past custom bags">${PAST.map((x, i) => {
      const on = !!p && p.ref === x.ref && p.series === x.series && p.size === x.size;
      return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on || (!p && i === 0) ? 0 : -1}" data-past="${i}">
        <b>${esc(x.label)}</b><span>${esc(x.order)}${x.date ? " · " + esc(x.date) : ""}${x.ref && x.ref !== x.order ? " · " + esc(x.ref) : ""}</span></button>`;
    }).join("")}</div>
    <p class="hint">${p ? `Reordering ${esc(p.label)} from ${esc(p.order || p.ref)}. The bag and weight above are set to match.` : "Pick the bags you want again."}</p>` + fallback;
}
$("pastPick").addEventListener("click", async e => {
  if(e.target.id === "pastSignIn"){ saveCurrent(); await persist(); location.href = SHOP.loginUrl; return; }
  if(e.target.id === "showManual"){ state.manualReorder = true; renderPastPick(); renderSummary(); $("reorderOf").focus(); return; }
  const b = e.target.closest("[data-past]"); if(!b) return;
  const x = PAST[+b.dataset.past], s = SERIES.find(z => z.p === x.series);
  state.reorderPick = x; state.reorderOf = x.ref; state.reorderOk = true; state.manualReorder = false;
  state.series = s.p; state.program = s.prog; if(x.size) state.size = x.size;
  render();
  $("pastPick").querySelector(`[data-past="${b.dataset.past}"]`)?.focus();
});
radioKeys($("pastPick"), "[data-past]");
$("reorderOk").addEventListener("change", e => { state.reorderOk = e.target.checked; renderSummary(); });
$("rightsOk").addEventListener("change", e => { state.rightsOk = e.target.checked; renderLayers(); renderSummary(); });

$("programTabs").addEventListener("click", e=>{
  const b=e.target.closest("[data-p]"); if(!b) return;
  if(b.dataset.p === state.program) return;
  // Switching program switches the bag too (else the stamp and price stay on the old program's bag):
  // to its twin in the new program (same carpet + speeds) if there is one, otherwise the first bag listed.
  const cur = SERIES.find(s => s.p === state.series), list = SERIES.filter(s => s.prog === b.dataset.p);
  const twin = cur && list.find(s => s.carpet === cur.carpet && s.speed.join() === cur.speed.join());
  state.program = b.dataset.p; state.series = (twin || list[0]).p;
  render();
});
$("seriesCards").addEventListener("click", e=>{
  const b=e.target.closest("[data-s]"); if(!b) return;
  state.series=b.dataset.s; const moved = advance(1);
  render(); const f=$("seriesCards").querySelector(`[data-s="${state.series}"]`); f&&f.focus({preventScroll:true});
  if(moved) scrollToStep();
});
// Mockup tabs. Picking a slow-side colour flips to the slow side; touching the design flips back.
state.face = "fast";
function showFace(f){
  if(state.face === f) return;
  state.face = f;
  $("tabFast").setAttribute("aria-selected", f === "fast");
  $("tabSlow").setAttribute("aria-selected", f === "slow");
  $("printFace").hidden = f !== "fast";
  $("carpetFace").hidden = f !== "slow";
  renderPreview();
}
// Keep the mockup exactly the editor's rendered size (the editor can be narrower than --mock
// when the window is), so the two always match pixel for pixel.
function syncMock(){
  const w = $("editor").getBoundingClientRect().width;
  if(w > 0) for(const id of ["printFace","carpetFace"]) $(id).style.width = w + "px";
}
if(window.ResizeObserver) new ResizeObserver(syncMock).observe($("editor"));
window.addEventListener("resize", syncMock);
$("tabFast").addEventListener("click", () => showFace("fast"));
$("tabSlow").addEventListener("click", () => showFace("slow"));
$("carpetBox").addEventListener("click", e=>{
  const b=e.target.closest("[data-c]"); if(!b) return;
  state.color=b.dataset.c; const moved = advance(3); showFace("slow"); renderCarpet(); renderPreview(); renderSummary();
  $("carpetBox").querySelector(`[data-c="${state.color}"]`).focus({preventScroll:true});
  if(moved) scrollToStep();
});
$("weightBox").addEventListener("click", e=>{
  const b=e.target.closest("[data-w]"); if(!b) return;
  state.size=b.dataset.w; const moved = advance(2); render();
  $("weightBox").querySelector(`[data-w="${state.size}"]`).focus({preventScroll:true});
  if(moved) scrollToStep();
});
radioKeys($("seriesCards"),"[data-s]"); radioKeys($("weightBox"),"[data-w]"); radioKeys($("carpetBox"),"[data-c]:not(:disabled)");

// ---- Carpet stock: live from the page's db; the staff panel writes it -----------
const FABRIC_NAMES = {CADID:"Cadid", ANCHORAGE:"Anchorage", VIEWMONT:"Viewmont", BUGLE:"Bugle", RUMBA:"Rumba"};
// On the website, stock comes from the Design Studio page's "Out-of-stock carpet colours"
// setting in Shopify admin (labels like "Cadid: Poppy").
if(SHOP && Array.isArray(SHOP.out)){
  const fabByName = Object.fromEntries(Object.entries(FABRIC_NAMES).map(([k, v]) => [v.toLowerCase(), k]));
  for(const label of SHOP.out){
    const [fn, cn] = String(label).split(":").map(x => x.trim().toLowerCase());
    const fab = fabByName[fn], c = fab && COLORS[fab].find(x => x[1].toLowerCase() === cn);
    if(c) state.out.add(stockKey(fab, c[0]));
  }
}
let stockRef = null, stockWriting = false;
function stockChanged(){ renderCarpet(); renderPreview(); renderSummary(); renderStockPanel(); }
function renderStockPanel(){
  if($("stockPanel").hidden) return;
  $("stockList").innerHTML = Object.entries(COLORS).map(([fab, opts]) => {
    const users = SERIES.filter(x => x.carpet === fab && PROGRAMS.includes(x.prog)).map(x => x.name).join(", ");
    return `<fieldset><legend>${FABRIC_NAMES[fab]} · ${esc(users)}</legend><div class="row">${opts.map(([code, name]) => {
      const k = stockKey(fab, code), out = state.out.has(k);
      return `<label class="${out?"is-out":""}"><input type="checkbox" data-k="${k}" ${out?"":"checked"} ${stockWriting?"disabled":""}>${esc(name)}</label>`;
    }).join("")}</div></fieldset>`;
  }).join("");
}
$("stockList").addEventListener("change", async e => {
  const k = e.target.dataset.k; if(!k || !stockRef || stockWriting) return;
  const next = new Set(state.out);
  e.target.checked ? next.delete(k) : next.add(k);
  stockWriting = true; $("stockMsg").textContent = "Saving…"; renderStockPanel();
  try {
    await stockRef.set({out: [...next].sort()});   // one write at a time; the snapshot updates the page
    $("stockMsg").textContent = "Saved. Customers see the change now.";
  } catch(err){
    $("stockMsg").textContent = "Couldn't save that change. Only the page owner and editors can change stock.";
  } finally { stockWriting = false; renderStockPanel(); }
});
(async () => {
  const cl = window.claude; if(!cl || !cl.use) return;          // local preview: everything in stock
  const db = await cl.use("db");
  if(db){
    stockRef = db.doc("settings/stock");
    stockRef.onSnapshot(snap => {
      const out = snap.exists ? (snap.data().out || []) : [];
      state.out = new Set(Array.isArray(out) ? out.filter(x => typeof x === "string") : []);
      stockChanged();
    }, () => {});                                                  // on failure, keep showing everything in stock
  }
  const user = await cl.use("user");
  if(db && user && await user.canEdit()){ $("stockPanel").hidden = false; renderStockPanel(); }
})();

function setQty(n){ state.qty=Math.max(1,Math.min(500,Math.round(n)||1)); $("qty").value=state.qty; renderSummary(); }
$("qMinus").onclick=()=>setQty(state.qty-1);
$("qPlus").onclick=()=>setQty(state.qty+1);
$("qty").addEventListener("change", e=>setQty(+e.target.value));

// ---- Design editor ------------------------------------------------------------
// Items on the bag live in state.images: kind "img" (upload), "title" (series title,
// always the bag name) or "text" (the customer's own text). All place and resize alike.
const isImg = im => (im.kind || "img") === "img";
const isText = im => im.kind === "title" || im.kind === "text";
const MIN_PX = 1088;   // spec: reject below 150 DPI at 7.25 in (7.25 x 150 = 1087.5 px)

// Machine-readable copy of the design for Design Helper's "Customer Design File" tool,
// which builds the order's .ai from it. Inches from the bag's top-left; spots TL..BR.
// v2 adds the series title, custom text, their colour and the customer's font.
function designSpec(){
  const s = series(), c = colorOf(s), r3 = n => Math.round(n * 1000) / 1000;
  const pos = im => ({x: r3(im.x / 100 * BAG_IN), y: r3(im.y / 100 * BAG_IN), w: r3(im.w / 100 * BAG_IN)});
  const title = state.images.find(im => im.kind === "title");
  return JSON.stringify({
    v: 2, ref: designRef(), bag: s.name, prog: s.prog, weight: weightText(s),
    slow: c ? c[1] + (printed(s) ? " (printed)" : "") : "Standard colour",
    // x/y = where the art is centred (inches): the spot, nudged inward where needed to stay in the safe area.
    stamp: Object.assign({kind: aclKind(s), spot: state.spots.acl}, state.spots.acl ? (a => ({x: r3(a.x / 100 * BAG_IN), y: r3(a.y / 100 * BAG_IN)}))(stampAt(aclKind(s), state.spots.acl)) : {}),
    logo: Object.assign({spot: state.spots.bc}, state.spots.bc ? (a => ({x: r3(a.x / 100 * BAG_IN), y: r3(a.y / 100 * BAG_IN), w: LOGOS.bc.w}))(stampAt("bc", state.spots.bc)) : {}),
    ink: state.ink, font: state.font ? state.font.name : null,
    title: title ? Object.assign({text: s.name}, pos(title)) : null,
    text: state.images.filter(im => im.kind === "text").map(im => Object.assign({text: im.text}, pos(im))),
    art: state.images.filter(im => isImg(im) && !im.sample).map(im => Object.assign({file: im.name}, pos(im))),
  });
}
function artworkSummary(){
  const real = state.images.filter(im => isImg(im) && !im.sample);
  if(!real.length) return "None uploaded (designer to create)";
  return real.map(im => `${im.name} (centre ${pct2in(im.x)} x ${pct2in(im.y)} in from top left, ${pct2in(im.w)} in wide)`).join("; ");
}
function textSummary(){
  const t = state.images.filter(im => im.kind === "text").map(im => `"${im.text}"`);
  return t.length ? t.join("; ") : "None";
}
// What still has to go on the bag before it can be ordered (spec: soft lock).
function missingElements(){
  const m = [];
  if(!state.spots.acl) m.push("the " + stampLabel(series()));
  if(!state.spots.bc) m.push("our Brotherhood logo");
  const gone = {};                                   // images still to re-add after opening a share link
  for(const im of state.images) if(im.missing) gone[im.name] = (gone[im.name] || 0) + 1;
  for(const [n, c] of Object.entries(gone)) m.push(`${n}${c > 1 ? ` (${c} places)` : ""} again (or remove it)`);
  if(hasOwnImages() && !state.rightsOk) m.push("the tick confirming you can use your images");
  if(!state.images.some(im => im.kind === "title")) m.push("the series title");
  return m;
}
const listWords = a => a.length < 2 ? a.join("") : a.slice(0, -1).join(", ") + " and " + a[a.length - 1];

// ---- Text items: drawn as SVG so they scale with their box, in the chosen font + colour.
// American Captain = the series font in the Master Bag Template (its BAG SERIES frame), so the
// preview matches what Design Helper builds and what gets pressed. Embedded as @font-face above.
const DEFAULT_FAMILY = '"American Captain", "Big Shoulders Display", Impact, "Arial Narrow", sans-serif';
const fontFamily = () => state.font ? `"${state.font.family}", ${DEFAULT_FAMILY}` : DEFAULT_FAMILY;
const measureCtx = document.createElement("canvas").getContext("2d");
function measureAr(text){           // width / height of the text's box at font-size 80 in a 100-tall box
  measureCtx.font = `400 80px ${fontFamily()}`;   // single-weight display fonts: no faux bold
  const w = measureCtx.measureText(text || " ").width;
  return Math.max(0.6, (w + 16) / 100);
}
function remeasureTexts(){
  const s = series();
  for(const im of state.images) if(isText(im)){
    if(im.kind === "title") im.text = s.name;
    const oldH = im.w / im.ar;       // keep the letters the same height when the text or font changes
    im.ar = measureAr(im.text); im.w = Math.min(160, oldH * im.ar);
  }
}
function textSvg(im, cls, sel){
  const vbw = Math.round(im.ar * 100);
  return `<svg class="layer txt${sel?" sel":""}" data-id="${im.id}" viewBox="0 0 ${vbw} 100" preserveAspectRatio="none"
    style="left:${im.x}%;top:${im.y}%;width:${im.w}%;aspect-ratio:${im.ar}" role="img" aria-label="${esc(im.text)}">
    <text x="${vbw/2}" y="53" text-anchor="middle" dominant-baseline="middle" font-size="80" font-weight="400"
      style="font-family:${esc(fontFamily())}" fill="${state.ink}">${esc(im.text)}</text></svg>`;
}

// ---- Brotherhood logo recoloured to the chosen colour (black → colour, white stays white).
const logoTint = {base:null, cache:{}};
(() => { const i = new Image(); i.onload = () => { logoTint.base = i; if(typeof designChanged === "function"){ renderDesign(); renderPreview(); } }; i.src = LOGOS.bc.src; })();
function tintedLogo(hex){
  if(!logoTint.base) return LOGOS.bc.src;
  if(logoTint.cache[hex]) return logoTint.cache[hex];
  const b = logoTint.base, cv = document.createElement("canvas"); cv.width = b.naturalWidth; cv.height = b.naturalHeight;
  const g = cv.getContext("2d"); g.drawImage(b, 0, 0);
  let d; try { d = g.getImageData(0, 0, cv.width, cv.height); } catch(_) { return LOGOS.bc.src; }
  const [r, gg, bl] = [1,3,5].map(i => parseInt(hex.slice(i, i+2), 16)), p = d.data;
  for(let i = 0; i < p.length; i += 4){
    if(!p[i+3]) continue;
    const t = (p[i] + p[i+1] + p[i+2]) / 765;          // 0 = black ink, 1 = white
    p[i] = r + (255 - r) * t; p[i+1] = gg + (255 - gg) * t; p[i+2] = bl + (255 - bl) * t;
  }
  g.putImageData(d, 0, 0);
  const keys = Object.keys(logoTint.cache); if(keys.length > 20) delete logoTint.cache[keys[0]];
  return (logoTint.cache[hex] = cv.toDataURL("image/png"));
}

// Draws the fast side into `el`. The editor gets guides, empty spots and handles;
// the mini preview in the sidebar gets only what prints.
function drawBag(el, editing){
  const s = series();
  let h = "";
  for(const im of state.images){
    const sel = editing && im.id === state.sel;
    if(isText(im)){ h += textSvg(im, "", sel); continue; }
    h += `<img class="layer${sel?" sel":""}${im.sample?" sample":""}" data-id="${im.id}" src="${im.url}" alt="${esc(im.name)}" draggable="false"
      style="left:${im.x}%;top:${im.y}%;width:${im.w}%">`;
  }
  h += editing ? TEMPLATE_SVG : CUT_SVG;   // the mockup mirrors the editor, cut edge only
  const used = {};
  if(state.spots.acl) used[state.spots.acl] = aclKind(s);
  if(state.spots.bc) used[state.spots.bc] = "bc";
  for(const p of SPOTS){
    const k = used[p.id];
    const src = k === "bc" ? tintedLogo(state.ink) : k && LOGOS[k].src;
    const at = k && stampAt(k, p.id);
    if(k) h += `<img class="stamp" src="${src}" alt="${LOGOS[k].name}" style="left:${at.x}%;top:${at.y}%;width:${LOGOS[k].w / BAG_IN * 100}%">`;
    else if(editing) h += `<div class="slot" style="left:${p.x}%;top:${p.y}%">${p.label}</div>`;
  }
  const selIm = editing && state.images.find(im => im.id === state.sel);
  if(selIm) h += `<div class="handle" data-handle="1" style="left:${selIm.x + selIm.w/2}%;top:${selIm.y + selIm.w/selIm.ar/2}%" title="Drag to resize"></div>`;
  el.innerHTML = h;
}

function renderSpots(){
  const s = series(), k = aclKind(s);
  $("aclTitle").textContent = LOGOS[k].name.replace(" stamp","") + " stamp";
  for(const [box, key, other, otherName] of [["spotsAcl","acl","bc","Our logo"],["spotsBc","bc","acl",stampLabel(s)]]){
    $(box).innerHTML = SPOTS.map(p => {
      const on = state.spots[key] === p.id, taken = state.spots[other] === p.id;
      return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on?0:-1}" data-spot="${p.id}" data-key="${key}" ${taken?"disabled":""}>
        ${p.label}${taken?`<small>${otherName}</small>`:""}</button>`;
    }).join("");
  }
}
// Real customer images on this bag (not the sample, not a still-missing share-link box).
const hasOwnImages = () => state.images.some(im => isImg(im) && !im.sample && !im.missing);
function renderLayers(){
  // The rights tick appears once the customer adds their own images, and is required from then on.
  $("rightsRow").hidden = !hasOwnImages();
  $("rightsOk").checked = !!state.rightsOk;
  $("layerList").innerHTML = state.images.map(im => {
    const sel = im.id === state.sel ? "sel" : "";
    if(im.kind === "title") return `<li class="${sel}" data-id="${im.id}"><span class="txt-thumb" style="color:${state.ink}">Aa</span>
      <div><div class="ln">Series title: ${esc(im.text)}</div><div class="lm">Required · ${pct2in(im.w)} in wide</div></div>
      <button type="button" data-remove="${im.id}" aria-label="Take the series title off">Remove</button></li>`;
    if(im.kind === "text") return `<li class="${sel}" data-id="${im.id}"><span class="txt-thumb" style="color:${state.ink}">T</span>
      <div><input type="text" data-edit="${im.id}" value="${esc(im.text)}" maxlength="40" aria-label="Your text"><div class="lm">${pct2in(im.w)} in wide</div></div>
      <button type="button" data-remove="${im.id}" aria-label="Remove this text">Remove</button></li>`;
    return `<li class="${sel}" data-id="${im.id}">
      <img src="${im.url}" alt=""><div><div class="ln">${esc(im.name)}</div>
      <div class="lm${im.missing ? " bad" : ""}">${im.missing ? "Not in the shared link. Add this file again and it drops into place." : im.sample ? "Replaced when you add an image" : im.vector ? `Vector · ${pct2in(im.w)} in wide` : `${pct2in(im.w)} in wide`}</div></div>
      <button type="button" data-remove="${im.id}" aria-label="Remove ${esc(im.name)}">Remove</button></li>`;
  }).join("");
  $("addTitle").disabled = state.images.some(im => im.kind === "title");
  const miss = missingElements();
  $("requiredNote").textContent = miss.length ? `Still needed before you can order: ${listWords(miss)}.` : "";
}
function renderDesign(){ remeasureTexts(); drawBag($("editor"), true); renderSpots(); renderLayers(); }
function designChanged(){ if(typeof showFace === "function") showFace("fast"); renderDesign(); renderPreview(); renderSummary(); }

// Sample layer so the bag isn't empty on first load; the first real image replaces it.
const SAMPLE_URL = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(SAMPLE_ART.replace("<svg ", '<svg width="400" height="400" '));
// The bag starts blank (user, 2026-09-30). SAMPLE_URL stays so older saved designs and share
// links that still hold the sample layer keep displaying it.

let nextId = 1;
function artNote(msg){ $("artStatus").hidden = !msg; $("artStatus").className = "art-status warn"; $("artMsg").textContent = msg || ""; }
// `file` is the customer's original upload: it goes to Shopify with the order and is kept
// with the saved design, so the designer gets the real file, not the preview.
function placeImage(name, url, ar, vector, file){
  // A design opened from a share link holds a labelled box where each image was; a file with the
  // same name drops into that box (same position and width).
  const ph = state.images.find(im => im.missing && im.name === name);
  if(ph){
    Object.assign(ph, {url, ar, vector, file, missing: false});
    state.sel = ph.id; designChanged(); return;
  }
  state.images = state.images.filter(im => !im.sample);
  const n = state.images.filter(isImg).length;
  const im = {id:"i"+(nextId++), kind:"img", name, url, ar, vector, file, x:50 + (n%3)*4, y:50 + (n%3)*4, w:45};
  if(im.ar < 1) im.w = 45 * im.ar;                // keep tall images inside the bag
  state.images.splice(state.images.findIndex(isText) < 0 ? state.images.length : state.images.findIndex(isText), 0, im);  // images under text
  state.sel = im.id;
  designChanged();
}
// PDFs can't be drawn in the browser, so they sit on the bag as a labelled box the designer replaces.
function pdfPlaceholder(name){
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect x="4" y="4" width="392" height="392" rx="18" fill="#f1f1ee" stroke="#8b928f" stroke-width="6" stroke-dasharray="18 12"/><text x="200" y="185" text-anchor="middle" font-family="Arial" font-weight="700" font-size="54" fill="#5b625f">PDF</text><text x="200" y="240" text-anchor="middle" font-family="Arial" font-size="22" fill="#5b625f">${esc(name).slice(0,28)}</text></svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}
function addFiles(files){
  const list = [...files], rejected = [];
  for(const f of list){
    const type = f.type || (/\.svg$/i.test(f.name) ? "image/svg+xml" : /\.pdf$/i.test(f.name) ? "application/pdf" : "");
    if(type === "application/pdf"){ placeImage(f.name, pdfPlaceholder(f.name), 1, true, f); continue; }   // vectors always pass
    if(!/^image\/(png|jpeg|webp|svg\+xml)$/.test(type)){ rejected.push(`${f.name} isn't a PNG, JPG, SVG or PDF`); continue; }
    const url = URL.createObjectURL(f), img = new Image();
    img.onload = () => {
      const w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
      if(type === "image/svg+xml"){ placeImage(f.name, url, w / h, true, f); return; }
      if(Math.min(w, h) < MIN_PX){    // spec: hard reject below 150 DPI at 7.25 in
        URL.revokeObjectURL(url);
        artNote(`${f.name} is ${w} × ${h} px, too small to print sharply on a 7.25 in bag. Upload a version at least ${MIN_PX} px on its shortest side, or a vector file (SVG, PDF or AI). Screenshots and photos from messages are usually too small.`);
        return;
      }
      artNote("");
      placeImage(f.name, url, w / h, false, f);
    };
    img.onerror = () => { URL.revokeObjectURL(url); artNote(`${f.name} couldn't be read. Try exporting it again as PNG.`); };
    img.src = url;
  }
  if(rejected.length) artNote(`${rejected.join("; ")}. Use PNG, JPG, SVG or PDF files.`);
}

// ---- Series title and custom text
function addTextItem(kind){
  const s = series(), text = kind === "title" ? s.name : "Your text";
  if(kind === "title" && state.images.some(im => im.kind === "title")) return;
  const ar = measureAr(text), h = kind === "title" ? 12 : 8;          // letter height in % of the bag
  const im = {id: kind === "title" ? "title" : "t" + (nextId++), kind, text, ar, w: Math.min(90, h * ar),
              x: 50, y: kind === "title" ? 72 : 30 + (state.images.filter(x => x.kind === "text").length % 4) * 8};
  state.images.push(im); state.sel = im.id;
  designChanged();
  if(kind === "text") setTimeout(() => { const i = document.querySelector(`[data-edit="${im.id}"]`); if(i){ i.focus(); i.select(); } }, 0);
}
$("addTitle").addEventListener("click", () => addTextItem("title"));
$("addText").addEventListener("click", () => addTextItem("text"));
$("layerList").addEventListener("input", e => {
  const id = e.target.dataset.edit; if(!id) return;
  const im = state.images.find(x => x.id === id); if(!im) return;
  im.text = e.target.value || " "; remeasureTexts();
  drawBag($("editor"), true); drawBag($("printFace"), false); renderSummary();
});

// ---- Font: the customer's own .ttf/.otf/.woff previews on the title and their text.
// The free-font links show whenever no font of theirs is in use (every path goes through here).
function showFontMsg(error){
  const FONT_SITES = 'Grab a free font from <a href="https://www.dafont.com" target="_blank" rel="noopener">DaFont</a>, <a href="https://fonts.google.com" target="_blank" rel="noopener">Google Fonts</a> or <a href="https://www.fontsquirrel.com" target="_blank" rel="noopener">Font Squirrel</a>, then upload the .ttf or .otf file here.';
  if(error) $("fontMsg").innerHTML = esc(error) + " " + FONT_SITES;
  else if(state.font) $("fontMsg").textContent = `Previewing ${state.font.name}. Dillon will use this font for your title and text.`;
  else if(state.missingFont) $("fontMsg").innerHTML = `This design used the font <b>${esc(state.missingFont)}</b>, which isn't in the shared link. Upload it again to use it, or keep our default. ` + FONT_SITES;
  else $("fontMsg").innerHTML = "Using our default font. Want a different look? " + FONT_SITES;
}
$("fontInput").addEventListener("change", async e => {
  const f = e.target.files[0]; e.target.value = ""; if(!f) return;
  try {
    const family = "CustomerFont" + (nextId++);
    const face = new FontFace(family, await f.arrayBuffer());
    await face.load(); document.fonts.add(face);
    state.font = {name: f.name, family, file: f}; state.missingFont = null;
    showFontMsg();
    $("fontReset").hidden = false;
  } catch(_) {
    showFontMsg(`${f.name} couldn't be opened as a font. Upload a .ttf, .otf or .woff file.`);
  }
  remeasureTexts(); designChanged();
});
$("fontReset").addEventListener("click", () => {
  state.font = null; state.missingFont = null; $("fontReset").hidden = true;
  showFontMsg();
  remeasureTexts(); designChanged();
});
if(document.fonts && document.fonts.load){
  // Load the embedded series font up front so text is measured in it, not a fallback.
  document.fonts.load('80px "American Captain"').catch(() => {}).then(() => document.fonts.ready)
    .then(() => { remeasureTexts(); renderDesign(); renderPreview(); });
}

// ---- Colour wheel: hue around, saturation outward, brightness on the slider.
const wheel = $("wheel"), wctx = wheel.getContext("2d");
const ink = {h:0, s:0, v:0.12};
function hsv2rgb(h, s, v){ const f = n => { const k = (n + h / 60) % 6; return v - v * s * Math.max(0, Math.min(k, 4 - k, 1)); }; return [f(5), f(3), f(1)].map(x => Math.round(x * 255)); }
function rgb2hsv(r, g, b){ r/=255; g/=255; b/=255; const mx = Math.max(r,g,b), mn = Math.min(r,g,b), d = mx - mn;
  let h = 0; if(d){ h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60; if(h < 0) h += 360; }
  return {h, s: mx ? d / mx : 0, v: mx}; }
const toHex = rgb => "#" + rgb.map(x => x.toString(16).padStart(2, "0")).join("").toUpperCase();
function drawWheel(){
  const W = wheel.width, R = W / 2, img = wctx.createImageData(W, W), p = img.data;
  for(let y = 0; y < W; y++) for(let x = 0; x < W; x++){
    const dx = x - R, dy = y - R, d = Math.hypot(dx, dy); if(d > R) continue;
    const [r, g, b] = hsv2rgb((Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360, d / R, Math.max(ink.v, 0.35));
    const i = (y * W + x) * 4; p[i] = r; p[i+1] = g; p[i+2] = b; p[i+3] = d > R - 1 ? 128 : 255;
  }
  wctx.putImageData(img, 0, 0);
  const a = ink.h * Math.PI / 180, mx = R + Math.cos(a) * ink.s * (R - 6), my = R + Math.sin(a) * ink.s * (R - 6);
  wctx.lineWidth = 3; wctx.strokeStyle = "#fff"; wctx.beginPath(); wctx.arc(mx, my, 8, 0, 7); wctx.stroke();
  wctx.lineWidth = 1.5; wctx.strokeStyle = "#000"; wctx.beginPath(); wctx.arc(mx, my, 10, 0, 7); wctx.stroke();
}
function setInk(hex, fromUser){
  state.ink = hex; $("inkSwatch").style.background = hex;
  if(document.activeElement !== $("inkHex")) $("inkHex").value = hex;
  $("inkLight").value = Math.round(ink.v * 100);
  drawWheel();
  if(fromUser){ drawBag($("editor"), true); drawBag($("printFace"), false); renderLayers(); renderSummary(); }
}
function inkFromHsv(){ setInk(toHex(hsv2rgb(ink.h, ink.s, ink.v)), true); }
function pickAt(e){
  const r = wheel.getBoundingClientRect(), R = r.width / 2, dx = e.clientX - r.left - R, dy = e.clientY - r.top - R;
  ink.h = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360; ink.s = Math.min(1, Math.hypot(dx, dy) / R);
  if(ink.v < 0.35) ink.v = 0.85;       // picking a hue from near-black: brighten so the colour shows
  inkFromHsv();
}
let wheelDrag = false;
wheel.addEventListener("pointerdown", e => { wheelDrag = true; try { wheel.setPointerCapture(e.pointerId); } catch(_){} pickAt(e); });
wheel.addEventListener("pointermove", e => { if(wheelDrag) pickAt(e); });
wheel.addEventListener("pointerup", () => wheelDrag = false);
wheel.addEventListener("keydown", e => {
  const k = {ArrowLeft:[-6,0], ArrowRight:[6,0], ArrowUp:[0,.05], ArrowDown:[0,-.05]}[e.key]; if(!k) return;
  e.preventDefault(); ink.h = (ink.h + k[0] + 360) % 360; ink.s = Math.min(1, Math.max(0, ink.s + k[1])); inkFromHsv();
});
$("inkLight").addEventListener("input", e => { ink.v = e.target.value / 100; inkFromHsv(); });
$("inkHex").addEventListener("input", e => {
  const v = e.target.value.trim(); if(!/^#?[0-9a-f]{6}$/i.test(v)) return;
  const hex = ("#" + v.replace("#","")).toUpperCase(), [r, g, b] = [1,3,5].map(i => parseInt(hex.slice(i, i+2), 16));
  Object.assign(ink, rgb2hsv(r, g, b)); setInk(hex, true);
});
document.querySelector(".ink-quick").addEventListener("click", e => {
  const b = e.target.closest("[data-ink]"); if(!b) return;
  const hex = b.dataset.ink, [r, g, bl] = [1,3,5].map(i => parseInt(hex.slice(i, i+2), 16));
  Object.assign(ink, rgb2hsv(r, g, bl)); setInk(hex, true);
});
setInk(state.ink, false);
$("artInput").addEventListener("change", e => { addFiles(e.target.files); e.target.value = ""; });
const drop=$("drop");
["dragenter","dragover"].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();drop.classList.add("over");}));
["dragleave","drop"].forEach(t=>drop.addEventListener(t,()=>drop.classList.remove("over")));
drop.addEventListener("drop", e=>{ e.preventDefault(); addFiles(e.dataTransfer.files); });

// ---- Concept artwork (user, 2026-10-06): reference images for the designer only. They ride along
// with the order as "Concept N" files and never touch the mockup, the spec or the print file.
const CONCEPT_MAX = 10, CONCEPT_MB = 20;
function renderConcepts(){
  $("conceptList").innerHTML = state.concepts.map(c => `<li>
    ${c.url ? `<img src="${c.url}" alt="">` : `<img src="${pdfPlaceholder(c.name)}" alt="">`}
    <span class="cn" title="${esc(c.name)}">${esc(c.name)}</span>
    <button type="button" data-unconcept="${c.id}" aria-label="Remove ${esc(c.name)}">Remove</button></li>`).join("");
}
function addConcepts(files){
  const bad = [];
  for(const f of [...files]){
    const isPdf = f.type === "application/pdf" || /\.pdf$/i.test(f.name);
    if(!isPdf && !/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)){ bad.push(`${f.name} isn't an image or PDF`); continue; }
    if(f.size > CONCEPT_MB * 1048576){ bad.push(`${f.name} is over ${CONCEPT_MB} MB`); continue; }
    if(state.concepts.length >= CONCEPT_MAX){ bad.push(`only ${CONCEPT_MAX} concept images fit on one bag`); break; }
    const img = !isPdf && /^image\/(png|jpeg|gif|webp|svg\+xml|avif|bmp)$/.test(f.type);   // browsers can't preview HEIC
    state.concepts.push({id: "c" + Math.random().toString(36).slice(2, 9), name: f.name, file: f, img, url: img ? URL.createObjectURL(f) : null});
  }
  $("conceptMsg").textContent = bad.length ? bad.join("; ") + "." : "";
  renderConcepts(); renderSummary();
}
$("conceptInput").addEventListener("change", e => { addConcepts(e.target.files); e.target.value = ""; });
const cdrop = $("conceptDrop");
["dragenter","dragover"].forEach(t => cdrop.addEventListener(t, e => { e.preventDefault(); cdrop.classList.add("over"); }));
["dragleave","drop"].forEach(t => cdrop.addEventListener(t, () => cdrop.classList.remove("over")));
cdrop.addEventListener("drop", e => { e.preventDefault(); addConcepts(e.dataTransfer.files); });
$("conceptList").addEventListener("click", e => {
  const b = e.target.closest("[data-unconcept]"); if(!b) return;
  const c = state.concepts.find(x => x.id === b.dataset.unconcept);
  if(c && c.url) URL.revokeObjectURL(c.url);
  state.concepts = state.concepts.filter(x => x !== c);
  $("conceptMsg").textContent = ""; renderConcepts(); renderSummary();
});

function removeImage(id){
  const im = state.images.find(x => x.id === id);
  if(im && !im.sample) URL.revokeObjectURL(im.url);
  state.images = state.images.filter(x => x.id !== id);
  if(state.sel === id) state.sel = null;
  designChanged();
}
$("layerList").addEventListener("click", e => {
  const rm = e.target.closest("[data-remove]");
  if(rm){ removeImage(rm.dataset.remove); return; }
  if(e.target.matches("input")) return;             // typing into a text item, don't re-render under the cursor
  const li = e.target.closest("[data-id]"); if(!li) return;
  state.sel = li.dataset.id; renderDesign(); $("editor").focus();
});
for(const box of ["spotsAcl","spotsBc"]){
  $(box).addEventListener("click", e => {
    const b = e.target.closest("[data-spot]"); if(!b || b.disabled) return;
    state.spots[b.dataset.key] = b.dataset.spot;       // taken spots are disabled, so two logos never share one
    designChanged();
    $(box).querySelector(`[data-spot="${b.dataset.spot}"]`).focus();
  });
  radioKeys($(box), "[data-spot]:not(:disabled)");
}

// Drag to move, corner handle to resize. Positions are kept in % of the bag.
const editor = $("editor");
let drag = null;
editor.addEventListener("pointerdown", e => {
  const handle = e.target.closest("[data-handle]"), layer = e.target.closest(".layer");
  if(!handle && !layer){ if(state.sel){ state.sel = null; renderDesign(); } return; }
  const im = handle ? state.images.find(x => x.id === state.sel) : state.images.find(x => x.id === layer.dataset.id);
  if(!im) return;
  e.preventDefault();
  showFace("fast");
  if(state.sel !== im.id){ state.sel = im.id; renderDesign(); }
  const r = editor.getBoundingClientRect();
  drag = {mode: handle ? "size" : "move", im, sx:e.clientX, sy:e.clientY, x:im.x, y:im.y, w:im.w, rw:r.width, rh:r.height};
  try { editor.setPointerCapture(e.pointerId); } catch(_) {}   // dragging still works without capture
});
editor.addEventListener("pointermove", e => {
  if(!drag) return;
  const dx = (e.clientX - drag.sx) / drag.rw * 100, dy = (e.clientY - drag.sy) / drag.rh * 100, im = drag.im;
  if(drag.mode === "move"){
    im.x = Math.min(100, Math.max(0, drag.x + dx));
    im.y = Math.min(100, Math.max(0, drag.y + dy));
  } else {
    im.w = Math.min(160, Math.max(6, drag.w + dx * 2));   // grows around its centre
  }
  drawBag(editor, true);
  drawBag($("printFace"), false);                         // mockup mirrors every movement
});
function endDrag(){ if(!drag) return; drag = null; renderLayers(); renderPreview(); renderSummary(); }
editor.addEventListener("pointerup", endDrag);
editor.addEventListener("pointercancel", endDrag);
editor.addEventListener("keydown", e => {
  const im = state.images.find(x => x.id === state.sel); if(!im) return;
  const step = e.shiftKey ? 2 : 0.5;
  const moves = {ArrowLeft:[-step,0], ArrowRight:[step,0], ArrowUp:[0,-step], ArrowDown:[0,step]};
  if(moves[e.key]){ e.preventDefault(); im.x += moves[e.key][0]; im.y += moves[e.key][1]; designChanged(); }
  else if(e.key === "Delete" || e.key === "Backspace"){ e.preventDefault(); removeImage(im.id); }
  else if(e.key === "+" || e.key === "="){ im.w = Math.min(160, im.w * 1.05); designChanged(); }
  else if(e.key === "-"){ im.w = Math.max(6, im.w / 1.05); designChanged(); }
});

$("notes").addEventListener("input", renderSummary);

// ---- Saved on this device (IndexedDB): the whole order, uploads and font included, so a
// refresh or the trip to the sign-in page never loses work. Cleared once it's in the cart.
const SAVE_KEY = "order";
let idbOpen = null, restoreDone = false, saveTimer = 0;
function idb(){
  return idbOpen || (idbOpen = new Promise((res, rej) => {
    try {
      const r = indexedDB.open("bc-design-studio", 1);
      r.onupgradeneeded = () => r.result.createObjectStore("kv");
      r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
    } catch(e){ rej(e); }
  }));
}
async function idbDo(mode, fn){
  const db = await idb();
  return new Promise((res, rej) => {
    const tx = db.transaction("kv", mode), req = fn(tx.objectStore("kv"));
    tx.oncomplete = () => res(req && req.result); tx.onerror = () => rej(tx.error); tx.onabort = () => rej(tx.error);
  });
}
function snapshot(){
  saveCurrent();
  return {v: 1, ref: REF, cur, designs: designs.map(d => Object.assign({}, d, {
    sel: null,
    images: d.images.map(im => { const o = Object.assign({}, im); if(String(o.url).startsWith("blob:")) delete o.url; return o; }),
    concepts: (d.concepts || []).map(c => ({id: c.id, name: c.name, file: c.file, img: c.img})),
    font: d.font ? {name: d.font.name, file: d.font.file || null} : null,
  }))};
}
function scheduleSave(){
  if(!restoreDone) return;                       // never overwrite a saved order before it's loaded
  clearTimeout(saveTimer);
  saveTimer = setTimeout(persist, 700);
}
async function persist(){
  clearTimeout(saveTimer);
  try { await idbDo("readwrite", s => s.put(snapshot(), SAVE_KEY)); $("savedNote").hidden = false; } catch(_) {}
}
async function clearSaved(){ try { await idbDo("readwrite", s => s.delete(SAVE_KEY)); } catch(_) {} }
// ---- Share links: the whole order (every bag's choices, placements, text and colour) packed into
// the link's #d= part. Uploaded images and fonts can't travel in a link (no server), so an image
// comes back as a labelled box in its place, and a file with the same name drops straight in.
const b64url = s => btoa(unescape(encodeURIComponent(s))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const unb64url = s => decodeURIComponent(escape(atob(s.replace(/-/g, "+").replace(/_/g, "/"))));
const r2 = n => Math.round(n * 100) / 100;
function shareLink(){
  saveCurrent();
  const data = {v: 1, cur, d: designs.map(d => ({
    p: d.program, s: d.series, w: d.size, c: d.color, q: d.qty, sp: d.spots, ink: d.ink,
    k: d.kind, ro: d.reorderOf, n: d.notes || "", f: d.font ? d.font.name : (d.missingFont || null),
    i: d.images.map(im => ({k: im.sample ? "sample" : (im.kind || "img"), t: isText(im) ? im.text : undefined,
      n: isImg(im) && !im.sample ? im.name : undefined, x: r2(im.x), y: r2(im.y), w: r2(im.w), ar: Math.round((im.ar || 1) * 1e4) / 1e4, v: im.vector ? 1 : undefined})),
  }))};
  return location.href.split("#")[0] + "#d=" + b64url(JSON.stringify(data));
}
function missingPlaceholder(name){
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect x="4" y="4" width="392" height="392" rx="18" fill="#fbf0d9" stroke="#9a6400" stroke-width="6" stroke-dasharray="18 12"/><text x="200" y="180" text-anchor="middle" font-family="Arial" font-weight="700" font-size="34" fill="#9a6400">Re-add image</text><text x="200" y="232" text-anchor="middle" font-family="Arial" font-size="22" fill="#6b4a00">${esc(name).slice(0,30)}</text></svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}
// Rebuild designs from a #d= link. Everything is checked against what the Studio offers, since a
// link can be edited by anyone. Returns null if there's no usable link.
function readShared(){
  const m = /^#d=([A-Za-z0-9_-]+)$/.exec(location.hash || "");
  if(!m) return null;
  let data; try { data = JSON.parse(unb64url(m[1])); } catch(_) { return null; }
  if(!data || !Array.isArray(data.d) || !data.d.length) return null;
  const num = (v, lo, hi, dflt) => Number.isFinite(+v) ? Math.min(hi, Math.max(lo, +v)) : dflt;
  const out = data.d.slice(0, 20).map(x => {
    const d = newDesign();
    const s = SERIES.find(z => z.p === x.s && PROGRAMS.includes(z.prog));
    if(s){ d.series = s.p; d.program = s.prog; }
    const sx = SERIES.find(z => z.p === d.series);
    if(WEIGHTS.some(w => w[0] === x.w)) d.size = x.w;
    const opts = optionsFor(sx); d.color = opts && opts.some(c => c[0] === x.c) ? x.c : (opts ? opts[0][0] : null);
    d.qty = Math.round(num(x.q, 1, 500, 1));
    d.step = 5;   // a shared design has already been through every step
    const spot = v => SPOTS.some(p => p.id === v) ? v : null;
    d.spots = {acl: spot(x.sp && x.sp.acl), bc: spot(x.sp && x.sp.bc)};
    if(d.spots.acl && d.spots.acl === d.spots.bc) d.spots.bc = null;
    if(/^#[0-9A-F]{6}$/i.test(x.ink || "")) d.ink = x.ink.toUpperCase();
    d.kind = x.k === "reorder" ? "reorder" : "new";
    d.reorderOf = String(x.ro || "").slice(0, 40);
    d.notes = String(x.n || "").slice(0, 2000);
    d.missingFont = x.f ? String(x.f).slice(0, 100) : null;
    d.images = (Array.isArray(x.i) ? x.i.slice(0, 40) : []).map(it => {
      const pos = {x: num(it.x, 0, 100, 50), y: num(it.y, 0, 100, 50), w: num(it.w, 6, 160, 40), ar: num(it.ar, 0.05, 20, 1)};
      if(it.k === "sample") return Object.assign({id: "sample", kind: "img", name: "Sample design", sample: true, px: 2000, url: SAMPLE_URL}, pos);
      if(it.k === "title") return Object.assign({id: "title", kind: "title", text: sx.name}, pos);
      if(it.k === "text") return Object.assign({id: "t" + (nextId++), kind: "text", text: String(it.t || "Your text").slice(0, 40)}, pos);
      const name = String(it.n || "image").slice(0, 120);
      return Object.assign({id: "i" + (nextId++), kind: "img", name, missing: true, vector: !!it.v, url: missingPlaceholder(name)}, pos);
    }).filter((im, i, a) => im.kind !== "title" || a.findIndex(z => z.kind === "title") === i);
    return d;
  });
  return {designs: out, cur: Math.round(num(data.cur, 0, out.length - 1, 0))};
}
const hasWork = saved => saved.designs.some(d => d.kind === "reorder" || d.spots.acl || d.spots.bc || d.images.some(im => !im.sample) || (d.concepts || []).length);
$("shareBtn").addEventListener("click", async () => {
  const url = shareLink(), box = $("shareBox"), inp = $("shareUrl");
  box.hidden = false; inp.value = url;
  let copied = false;
  try { await navigator.clipboard.writeText(url); copied = true; } catch(_) {}
  if(!copied){ inp.focus(); inp.select(); }
  const imgs = designs.some(d => d.images.some(im => isImg(im) && !im.sample)) || designs.some(d => d.font);
  $("shareMsg").textContent = (copied ? "Link copied. " : "Copy this link. ") + "It opens this design on any device." +
    (imgs ? " Uploaded images and fonts aren't in the link, so whoever opens it adds those files again." : "");
});

async function restore(){
  let saved = null;
  try { saved = await idbDo("readonly", s => s.get(SAVE_KEY)); } catch(_) {}
  const shared = readShared();
  if(shared){
    history.replaceState(null, "", location.href.split("#")[0]);   // a refresh keeps the saved copy instead
    const ok = !(saved && Array.isArray(saved.designs) && saved.designs.length && hasWork(saved))
      || confirm("Open the shared design? It replaces the design saved on this device.");
    if(ok){
      designs = shared.designs; REF = newRef();
      showDesign(shared.cur);
      const miss = designs.reduce((n, d) => n + d.images.filter(im => im.missing).length, 0);
      if(miss) artNote(`Opened a shared design. Add the ${miss === 1 ? "image" : `${miss} images`} marked "Re-add image" again. Each one drops into its place when you add a file with the same name.`);
      restoreDone = true; persist();
      return;
    }
  }
  if(saved && Array.isArray(saved.designs) && saved.designs.length){
    // The sample artwork is gone (user, 2026-09-30): drop it from older saves, and don't bring
    // back a save with nothing of the customer's in it, so they get today's fresh defaults.
    for(const d of saved.designs) d.images = (d.images || []).filter(im => !im.sample);
    if(!hasWork(saved)) saved = null;
  }
  if(saved && Array.isArray(saved.designs) && saved.designs.length){
    let maxId = 0;
    for(const d of saved.designs){
      if(!d.step) d.step = 5;   // saved before the step-by-step layout: leave every step open
      d.concepts = (d.concepts || []).filter(c => c && c.file).map(c => Object.assign(c, {url: c.img ? URL.createObjectURL(c.file) : null}));
      for(const im of d.images){
        if(!im.url && im.file) im.url = URL.createObjectURL(im.file);
        const n = parseInt(String(im.id).slice(1), 10); if(n > maxId) maxId = n;
      }
      if(d.font && d.font.file){
        try {
          const family = "CustomerFont" + (++maxId), face = new FontFace(family, await d.font.file.arrayBuffer());
          await face.load(); document.fonts.add(face); d.font.family = family;
        } catch(_) { d.font = null; }
      } else d.font = null;
    }
    nextId = Math.max(nextId, maxId + 1);
    REF = saved.ref || REF; designs = saved.designs;
    showDesign(Math.min(Math.max(0, saved.cur || 0), designs.length - 1));
    $("savedNote").hidden = false;
  }
  restoreDone = true;
}
// Two clicks instead of confirm(): pop-ups are blocked in some places (e.g. Shopify's theme editor).
let startOverArmed = 0;
$("startOver").addEventListener("click", async () => {
  const b = $("startOver");
  if(!startOverArmed){
    b.textContent = "Click again to clear your design";
    startOverArmed = setTimeout(() => { startOverArmed = 0; b.textContent = "Start over"; }, 4000);
    return;
  }
  clearTimeout(startOverArmed);
  await clearSaved(); location.reload();
});

// ---- Website checkout: each bag design is its own cart line (so each gets its own proof in
// ApprovePro) carrying the customer's uploaded files; the full details go on as cart attributes,
// exactly as in the prototype, so the Design Desk reads them the same way.
async function addToShopifyCart(){
  const lines = orderLines();
  for(let i = 0; i < designs.length; i++){
    const fd = new FormData();
    withDesign(i, () => {
      const s = series(), c = colorOf(s);
      fd.append("id", productOf(s).variant);
      fd.append("quantity", String(state.qty));
      fd.append("properties[Design ref]", designRef());
      fd.append("properties[Bag]", `${s.name} (${s.prog}), ${weightText(s)}`);
      fd.append("properties[Slow side]", c ? colorLabel(s, c) : "Standard colour");
      if(isReorder()) fd.append("properties[Reorder of]", state.reorderOf.trim());
      else {
        state.images.filter(im => isImg(im) && !im.sample && im.file)
          .forEach((im, n) => fd.append(`properties[Artwork ${n + 1}]`, im.file, im.name));
        if(state.font && state.font.file) fd.append("properties[Font file]", state.font.file, state.font.name);
        state.concepts.forEach((c, n) => fd.append(`properties[Concept ${n + 1}]`, c.file, c.name));
      }
    });
    const r = await fetch(SHOP.root + "cart/add.js", {method: "POST", body: fd, headers: {Accept: "application/json"}});
    if(!r.ok){
      let why = ""; try { const j = await r.json(); why = j.description || j.message || ""; } catch(_) { why = `error ${r.status}`; }
      throw new Error(`Bag ${i + 1} couldn't be added to the cart${why ? ": " + why : ""}. Nothing was charged. Please try again.`);
    }
  }
  const r = await fetch(SHOP.root + "cart/update.js", {method: "POST",
    headers: {"Content-Type": "application/json", Accept: "application/json"},
    body: JSON.stringify({attributes: lines, note: orderNote()})});
  if(!r.ok) throw new Error("Your bags are in the cart, but the design details didn't save. Please try again.");
}
$("cartBtn").addEventListener("click", async e => {
  if(!SHOP) return;                              // prototype: the link is the cart permalink
  e.preventDefault();
  const cb = $("cartBtn");
  if(cb.getAttribute("aria-disabled") === "true" || cb.dataset.busy) return;
  $("cartErr").hidden = true;
  if(!SHOP.customer){                            // spec: a Shopify customer account at submit
    cb.dataset.busy = "1"; cb.textContent = "Saving your design…";
    await persist();
    location.href = SHOP.loginUrl;
    return;
  }
  cb.dataset.busy = "1";
  const label = cb.textContent;
  cb.textContent = designs.some(d => d.kind !== "reorder" && (d.images.some(im => im.file) || (d.concepts || []).length)) ? "Uploading your artwork…" : "Adding to cart…";
  try {
    await addToShopifyCart();
    await clearSaved();
    location.href = SHOP.root + "cart";
  } catch(err){
    $("cartErr").textContent = err.message; $("cartErr").hidden = false;
    cb.textContent = label; delete cb.dataset.busy;
  }
});
if(SHOP){
  $("cartBtn").removeAttribute("target");
  $("checkoutNote").textContent = SHOP.customer ? "Your artwork uploads with it." : "You'll sign in first. Your design is saved while you do.";
}

render();
restore().then(() => {
  // ?reorder=1 (from the cart's "Reorder in the Design Studio" button): open this bag as a reorder.
  if(new URLSearchParams(location.search).has("reorder")){
    if(state.kind !== "reorder"){ state.kind = "reorder"; render(); }
    const u = new URL(location.href); u.searchParams.delete("reorder"); history.replaceState(null, "", u.toString());
    $("reorderStep").scrollIntoView({block: "start"});
  }
  scheduleSave();
});

})();
